// RUN THIS CODE TO PRINT ORDERED VERSION OF SPEC SHEET DATA TO CONSOLE
//
// function preserveUndefinedReplacer(_: string, value: unknown) {
// 		return value === undefined ? null : value
// 	}
// console.log(
// 	JSON.stringify(
// 		reorderVesselProperties(VESSELS_SPEC_SHEET_DATA_CLEAN),
// 		preserveUndefinedReplacer,
// 		4
// 	)

import {
	PartialMetadataObject,
	vesselMetadataTypeParser,
} from "@pages/DatabasePage/plantMetadata/PlantMetadata"
import { common } from "@utils/common"
import { CustomerData } from "api"

type VesselData = Record<string, PartialMetadataObject | null>

export function reorderVesselProperties<T extends VesselData>(vessels: T) {
	const reordered = {}

	for (const [vesselName, vesselData] of Object.entries(vessels)) {
		if (vesselData === null) {
			reordered[vesselName] = null
			continue
		}
		const newVesselData: PartialMetadataObject = {
			"Vessel built": undefined,
			"Vessel design": undefined,
			"Class definition": undefined,
			"Length o.a.": undefined,
			"Length b.p.": undefined,
			"Breadth mld": undefined,
			Bext: undefined,
			Depth: undefined,
			"Design draft": undefined,
			"Summer draft": undefined,
			"Scantling draft": undefined,
			Accommodation: undefined,
			"Service speed": undefined,
			Charterer: undefined,
			CapacityName: undefined,
			CapacityUnit: undefined,
			filterGroup: undefined,
			isUnderConfiguration: undefined,
			additionalProps: undefined,
		}

		for (const key of Object.keys(newVesselData)) {
			if (key in vesselData) {
				newVesselData[key] = vesselData[key]
			}
		}

		reordered[vesselName] = newVesselData
	}

	return reordered
}

export const getVesselSpecSheetData = (currentCompany: string | undefined): VesselData => {
	const plants: CustomerData["plants"] =
		currentCompany !== undefined
			? (common.companyDataFromCompanyName.get(currentCompany)?.plants ?? {})
			: {}

	const specSheetData: VesselData = {}
	Object.entries(plants).forEach(([name, data]) => {
		try {
			const metaData = vesselMetadataTypeParser.parse(data.metaData)

			specSheetData[name] = metaData
		} catch (error) {
			specSheetData[name] = null
		}
	})
	return specSheetData
}

export const VESSELS_SPEC_SHEET_DATA_CLEAN: { [vesselName: string]: PartialMetadataObject } = {
	// ALTERA
	"Altera Thule": {
		"Vessel built": null,
		"Vessel design": null,
		"Class definition": [
			"✠ 1A Tanker for oil BIS BMON Bow loading BWM(T) CCO Clean(Design) COAT-PSPC(B, C) COMF(C-3, V-3) CSA(FLS2) CSR DYNPOS(AUTR) E0 ECA (SOx-A) ESP ESV(DP[HIL-IS]) F(A, M, C) HELDK(S, H) LCS NAUT(AW, ICS) Plus Recyclable TMON(oil lubricated) VCS(2, B) ER(SCR, TIER III)",
		],
		"Length o.a.": "278.996 m",
		"Length b.p.": "264.485 m",
		"Breadth mld": "49 m",
		Bext: "49.04 m",
		Depth: "24.5 m",
		"Design draft": "17.2 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Altera Wave": {
		"Vessel built": "2021",
		"Vessel design": null,
		"Class definition": [
			"✠ 1A Tanker for oil BIS BMON Bow loading Battery(Power) BWM(T) CCO Clean(Design) COAT-PSPC(B, C) COMF(C-3, V-3) CSA(FLS2) CSR DYNPOS(AUTR) E0 ECA(SOx-A) ESP F(A, M, C) Gas fuelled HELDK(S, H, CAA-N) HMON(A1, B, C, G4, O3, W1) LCS NAUT(AW) Plus Recyclable RP(2, 50) SPM TMON(oil lubricated) VCS(2, B)",
		],
		"Length o.a.": "244.85 m",
		"Length b.p.": "233 m",
		"Breadth mld": "43.8 m",
		Bext: "43.84 m",
		Depth: "22.4 m",
		"Design draft": "15 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Altera Wind": {
		"Vessel built": "2021",
		"Vessel design": null,
		"Class definition": [
			"✠ 1A Tanker for oil BIS BMON Bow loading Battery(Power) BWM(T) CCO Clean(Design) COAT-PSPC(B, C) COMF(C-3, V-3) CSA(FLS2) CSR DYNPOS(AUTR) E0 ECA(SOx-A) ESP F(A, M, C) Gas fuelled HELDK(S, H, CAA-N) HMON(A1, B, C, G4, O3, W1) LCS NAUT(AW) Plus Recyclable RP(2, 50) SPM TMON(oil lubricated) VCS(2, B)",
		],
		"Length o.a.": "244.85 m",
		"Length b.p.": "233 m",
		"Breadth mld": "43.8 m",
		Bext: "43.84 m",
		Depth: "22.4 m",
		"Design draft": "15 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Aurora Spirit": {
		"Vessel built": "2021",
		"Vessel design": null,
		"Class definition": [
			"✠ 1A Tanker for oil BIS BMON Bow loading Battery(Safety) BWM(T) CCO Clean(Design) COAT-PSPC(B, C) COMF(C-3, V-3) CSA(FLS2) CSR DYNPOS(AUTR) E0 ECA(SOx-A) ESP F(A, M, C) Gas fuelled HELDK(S, H, CAA-N) HMON(A1, B, C, G4, O3, W1) LCS NAUT(AW) Plus Recyclable RP(2, 50) SPM TMON(oil lubricated) VCS(2, B, 3)",
		],
		"Length o.a.": "276.65 m",
		"Length b.p.": "265.01 m",
		"Breadth mld": "46 m",
		Bext: "46.05 m",
		Depth: "23.4 m",
		"Design draft": "15.4 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Beothuk Spirit": {
		"Vessel built": "2017",
		"Vessel design": null,
		"Class definition": [
			"✠ 1A Tanker for oil BIS BMON Bow loading BWM(T) CCO Clean(Design) COAT-PSPC(B; C) COMF(C-3, V-3) CSA(FLS2) CSR DYNPOS(AUTR) E0 ECA(SOx-A) ESP ESV(DP[HIL-IS], PMS[HIL-IS], SPT[HIL-IS]) F(A, M, C) HELDK(S, H) NAUT(AW, ICS) OPP-F Plus Recyclable TMON VCS(2, B)",
		],
		"Length o.a.": "278.97 m",
		"Length b.p.": "264.49 m",
		"Breadth mld": "49.00 m",
		Bext: "49.04 m",
		Depth: "24.5 m",
		"Design draft": "17.2 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Bossa Nova Spirit": {
		"Vessel built": "2013",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "282.00 m",
		"Length b.p.": null,
		"Breadth mld": "49 m",
		Bext: null,
		Depth: "23.6 m",
		"Design draft": "16.2 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Dorset Spirit": {
		"Vessel built": "2018",
		"Vessel design": null,
		"Class definition": [
			"✠ 1A Tanker for oil BIS BMON Bow loading BWM(T) CCO Clean(Design) COAT-PSPC(B; C) COMF(C-3, V-3) CSA(FLS2) CSR DYNPOS(AUTR) E0 ECA(SOx-A) ESP ESV(DP[HIL-IS], PMS[HIL-IS], SPT[HIL-IS]) F(A, M, C) HELDK(S, H) NAUT(AW, ICS) OPP-F Plus Recyclable TMON VCS(2, B)",
		],
		"Length o.a.": "279.04 m",
		"Length b.p.": "264.5 m",
		"Breadth mld": "49 m",
		Bext: "49.04 m",
		Depth: "24.5 m",
		"Design draft": "17.22 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Lambada Spirit": {
		"Vessel built": null,
		"Vessel design": null,
		"Class definition": [
			"ABS, + A1E, Oil Carrier, CSR, AB-CM, DPS-2, SH, SHCM, SH-DLA, SFA(25), HIMP, RES, PMA, CPS, IGS-BALLAST, +AMS, +ACCU, +APS, NIBS, ESP, VEC-L, TCM, R1(single shaft), UWILD, POT, ENVIRO+, GP, BLU, BWE, Statement of Compliance for DNV’s F-AMC, HM1+R Slam Warning, HM2+R Hull Girder Stress",
		],
		"Length o.a.": "282 m",
		"Length b.p.": null,
		"Breadth mld": "49 m",
		Bext: null,
		Depth: null,
		"Design draft": "16.20 m",
		"Summer draft": null,
		"Scantling draft": "17.2 m",
		Accommodation: "34+6 persons",
		"Service speed": "14.5 knots",
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Cargo tanks incl. slop tanks": ["165539 m³"],
			"Slop tanks": ["5888 m³"],
			"Fuel tanks": ["3135 m³"],
			"Gas oil/diesel oil tanks": ["544 m³"],
			"Fresh water tanks": ["500 m³"],
			"Ballast tanks incl. peak tanks": ["45475 m³"],
			"Main eng.": ["MAN 6S70ME-C", "14270 kW"],
			"Aux. eng.": ["2 HHI x 9H32/40", "4500 kW"],
			"Aux. eng. II": ["2 HHI x 6H32/40", "3000 kW"],
			"El. Power": ["6.6 kV / 440 V"],
			"Aux. Boiler": ["2 x 30 tons/hr"],
			Economiser: ["1 x 1,6 tons/hr"],
			"Main propeller": ["4 blades", "1 CPP"],
			Rudder: ["High Lift", "1"],
			"Steering gear": ["1"],
			"Forw. tunnel thruster": ["1 x 2200 kW"],
			"Forw. azimuth thruster": ["2 x 2200 kW"],
			"Aft azimuth thruster": ["1 x 2200 kW"],
			"Aft tunnel thruster": ["1 x 2200 kW"],
			"Brazil type – capacity": ["8000 m³/h"],
			"Traction winch": ["700 kN"],
			"Hose handling winch": ["400 kN"],
			"Service crane": ["1 x 5 tons"],
			"Cargo tanks / slop tanks": ["12 / 2"],
			Segregation: ["3"],
			"Cargo pumps": ["3 x 3,800 m³/h"],
			"Cargo stripping": ["1 x 240 m³/h"],
			"Cargo strupping eductors": ["2 x 600 m³/h"],
			"Inert gas generator": ["14,250 m³/h"],
			"Inert gas topping-up generator": ["500 m³/h"],
			"Ballast pumps": ["2 x 2,500 m³/h"],
			Navigation: ["2 radars, 2 ECDIS, 3 gyros,", "adaptive autopilot, 2 DGPS, AIS, VDR"],
			DP: ["K-POS, Artemis,  2 DARPS, Cyscan,", "Blom, RPMS, BLS telemetry"],
		},
	},
	"Norse Spirit": {
		"Vessel built": "2017",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "280 m",
		"Length b.p.": null,
		"Breadth mld": "49 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "17.2 m",
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Peary Spirit": {
		"Vessel built": "2011",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "249 m",
		"Length b.p.": null,
		"Breadth mld": "44 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "15.02 m",
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Rainbow Spirit": {
		"Vessel built": "2021",
		"Vessel design": null,
		"Class definition": [
			"✠ 1A Tanker for oil BIS BMON Bow loading Battery(Safety) BWM(E(s), T) CCO Clean(Design) COAT-PSPC(B, C) COMF(C-3, V-3) CSA(FLS2) CSR DYNPOS(AUTR) E0 ECA(SOx-A) ESP F(A, M, C) Gas fuelled HELDK(S, H, CAA-N) HMON(A1, B, C, G1, O3, W1) LCS NAUT(AW) Plus Recyclable RP(2, 50) SPM TMON(oil lubricated) VCS(2, B, 3)",
		],
		"Length o.a.": "276.65 m",
		"Length b.p.": "265.01 m",
		"Breadth mld": "46 m",
		Bext: "46.05 m",
		Depth: "23.4 m",
		"Design draft": "15.4 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Samba Spirit": {
		"Vessel built": "2013",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "282.00 m",
		"Length b.p.": null,
		"Breadth mld": "49 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Scott Spirit": {
		"Vessel built": "2011",
		"Vessel design": null,
		"Class definition": [
			"✠1A1, CSR, Tanker for Oil ESP, BOW LOADING, SBM, COMF-V(3)C(3), HELDK-SH, OPP-F, RP, E0, ESV-DP[HIL] F-AMC CCO, DYNPOS-AUTR(A), NAUT-AW, VCS-2, CLEAN DESIGN, BWM-E(s), COAT-PSPC, CSA-2, PLUS-2, BIS, TMON",
		],
		"Length o.a.": "250.00 m",
		"Length b.p.": null,
		"Breadth mld": "43.80 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "15.00 m",
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Sertanejo Spirit": {
		"Vessel built": null,
		"Vessel design": null,
		"Class definition": [
			"ABS, + A1E, Oil Carrier, CSR, AB-CM, DPS-2, SH, SHCM, SH-DLA, SFA(25), HIMP, RES, PMA, CPS, IGS-BALLAST, +AMS, +ACCU, +APS, NIBS, ESP, VEC-L, TCM, R1(single shaft), UWILD, POT, ENVIRO+, GP, BLU, BWE, Statement of Compliance for DNV’s F-AMC, HM1+R Slam Warning, HM2+R Hull Girder Stress",
		],
		"Length o.a.": "282 m",
		"Length b.p.": null,
		"Breadth mld": "49 m",
		Bext: null,
		Depth: null,
		"Design draft": "16.20 m",
		"Summer draft": null,
		"Scantling draft": "17.2 m",
		Accommodation: "34+6 persons",
		"Service speed": "14.5 knots",
		Charterer: "--",
		CapacityName: "Deadweight",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Cruising range": ["18.000 nm"],
			"Cargo tanks incl. slop tanks": ["165539 m³"],
			"Slop tanks": ["5888 m³"],
			"Fuel tanks": ["3135 m³"],
			"Gas oil/diesel oil tanks": ["544 m³"],
			"Fresh water tanks ": ["500 m³"],
			"Ballast tanks incl. peak tanks": ["45475 m³"],
			"Main eng.": ["MAN 6S70ME-C", "14270 kW"],
			"Aux. eng.": ["2 HHI x 9H32/40", "4500 kW"],
			"Aux. eng. II": ["2 HHI x 6H32/40", "3000 kW"],
			"El. Power": ["6.6 kV / 440 V"],
			"Aux. Boiler": ["2 x 30 tons/hr"],
			Economiser: ["1 x 1,6 tons/hr"],
			"Main propeller": ["4 blades", "1 CPP"],
			Rudder: ["High Lift", "1"],
			"Steering gear": ["1"],
			"Forw. tunnel thruster": ["1 x 2200 kW"],
			"Forw. azimuth thruster": ["2 x 2200 kW"],
			"Aft azimuth thruster": ["1 x 2200 kW"],
			"Aft tunnel thruster": ["1 x 2200 kW"],
			"Brazil type – capacity": ["8000 m³/h"],
			"Traction winch": ["700 kN"],
			"Hose handling winch": ["400 kN"],
			"Service crane": ["1 x 5 tons"],
			"Cargo tanks / slop tanks": ["12 / 2"],
			Segregation: ["3"],
			"Cargo pumps": ["3 x 3,800 m³/h"],
			"Cargo stripping": ["1 x 240 m³/h"],
			"Cargo strupping eductors": ["2 x 600 m³/h"],
			"Inert gas generator": ["14,250 m³/h"],
			"Inert gas topping-up generator": ["500 m³/h"],
			"Ballast pumps": ["2 x 2,500 m³/h"],
			Navigation: ["2 radars, 2 ECDIS, 3 gyros,", "adaptive autopilot, 2 DGPS, AIS, VDR"],
			DP: ["K-POS, Artemis,  2 DARPS, Cyscan,", "Blom, RPMS, BLS telemetry"],
		},
	},
	// DOF
	Geoholm: {
		"Vessel built": "2006",
		"Vessel design": ["MT 6000", "Mk II"],
		"Class definition": ["✠ 1A1 Clean COMF(V-3) DK(+) DYNPOS(AUTR) E0 HELDK SF"],
		"Length o.a.": "85.65 m",
		"Length b.p.": null,
		"Breadth mld": "19.7 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.1 m",
		"Scantling draft": null,
		Accommodation: "70",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1530 kW"],
			"Bow thruster": ["1 x 883 kW"],
			"Azimuth thruster": ["2 x 883 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["890 m²"],
			"Deck strength": ["5 t/m²"],
			"Deck capacity": ["1100 t"],
			"Fuel oil": ["1208 m³"],
			"Pot water": ["705 m³"],
			"Helideck dim": ["20.9 m diam", "12 t"],
			"ROV hangar": ["133 m²"],
			"Deck crane": ["SWL 5 t", "SWL 3 t"],
			"Offshore crane": ["SWL 90/100 t", "2140 m/1939 m"],
		},
	},
	"Skandi Acergy": {
		"Vessel built": "2008",
		"Vessel design": ["AKER OSCV", "06L"],
		"Class definition": [
			"✠ 1A1 ICE-C SF COMF-V(3)C(3) HELDK-SH CRANE E0 DYNPOS-AUTRO NAUT-AW Clean(Design) DK(+) TMON",
		],
		"Length o.a.": "156.9 m",
		"Length b.p.": null,
		"Breadth mld": "27.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.5 m",
		"Scantling draft": null,
		Accommodation: "140",
		"Service speed": null,
		Charterer: "DOF Subsea UK",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 3840 kW", "4 x 2895 kW"],
			"Bow thruster": ["2 x 1900 kW"],
			"Azimuth thruster": ["2 x 1500 kW"],
			"Stern thruster": ["2 x 3000 kW"],
			"Deck dimensions": ["2100 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["7000 t"],
			"Fuel oil": ["2306 m³"],
			"Pot water": ["1500 m³"],
			"Helideck dim": [" 21 m diam", "12 t"],
			Moonpool: ["(7.2 x 7.2 m)", "+ 2 x (5.6 x", "3.5 m)"],
			"ROV hangar": ["292 m²"],
			"Deck crane": ["2 x SWL 3 t"],
			"Offshore crane": ["SWL 400 t", "3000 m"],
			"Offshore crane II": ["SWL 50/100 t", "2000/1000 m"],
			Tower: ["FLS 125 t"],
		},
	},
	"Skandi Achiever": {
		"Vessel built": "2007",
		"Vessel design": ["AKER DSV 06"],
		"Class definition": [
			"✠ 1A1 ICE-C COMF-V(3) HELDK DSV-SAT E0 DYNPOS-AUTR (A) NAUT-AW Clean(Design) DK(+)",
		],
		"Length o.a.": "105.9 m",
		"Length b.p.": null,
		"Breadth mld": "21.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.6 m",
		"Scantling draft": null,
		Accommodation: "100",
		"Service speed": null,
		Charterer: "DOF Subsea Brazil",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1665 kW", "2 x 1980 kW"],
			"Bow thruster": ["1 x 1500 kW"],
			"Azimuth thruster": ["2 x 1500 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimensions": ["735 m² +", "(Mezz deck = 153 m²)"],
			"Deck strength": ["5 - 10 t/m²"],
			"Deck capacity": ["1300 t"],
			"Fuel oil": ["1201 m³"],
			"Pot water": ["1088 m³"],
			"Helideck dim": ["20.9 m diam", "12 t"],
			Moonpool: ["4.2 x 4.2 m"],
			"ROV hangar": ["137 m²"],
			"Deck crane": ["SWL 3 t"],
			"Seabed crane": ["SWL 5 t"],
			"Offshore crane": ["SWL 140 t", "2500 m"],
			"Diving system": ["18 men", "saturated", "diving system", "installed"],
		},
	},
	"Skandi Acu": {
		"Vessel built": "2016",
		"Vessel design": ["VARD 3 05"],
		"Class definition": [
			"✠ 1A1 E0 DYNPOS-AUTR DK (+) CRANE HELDK-SH BIS Clean(Design) NAUT-AW Comf-V(3) C(3) SPS BWM (T) Recyclable SF",
		],
		"Length o.a.": "145.9 m",
		"Length b.p.": null,
		"Breadth mld": "30.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.5 m",
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["6 x 3840 kW"],
			"Bow thruster": ["3 x 2400 kW"],
			"Azimuth thruster": ["1 x 2000 kW"],
			"Stern thruster": ["3 x 3700 kW"],
			"Deck dimensions": ["3000 m²"],
			"Deck strength": ["10 t/m²"],
			"Fuel oil": ["2450 m³"],
			"Pot water": ["1750 m³"],
			Moonpool: ["9.1 m x 7.2 m"],
			"Helideck dim": ["20.8 m dia", "12 t"],
			"Deck crane": ["1 x SWL 6 t", "1 x SWL 10 t", "2 x SWL 50 t"],
			"Offshore crane": ["1 x SWL 50 t"],
			Laytower: ["650 t"],
		},
	},
	"Skandi Africa": {
		"Vessel built": "2015",
		"Vessel design": ["VARD OSCV 12"],
		"Class definition": [
			"✠  1A1 Offshore service vessel SPS BIS BWM(T) Clean(Design) COMF(C-3, V-3) Crane DEICE DK(+) DYNPOS(AUTRO) E0 HELDK(S, H) LFL(*) NAUT(AW) Recyclable SF VIBR Winterized(Basic)",
		],
		"Length o.a.": "160.9 m",
		"Length b.p.": null,
		"Breadth mld": "32.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "9.25 m",
		"Scantling draft": null,
		Accommodation: "140",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 3840 kW", "2 x 4320 kW"],
			"Bow thruster": ["2 x 2800 kW"],
			"Azimuth thruster": ["2 x 2200 kW"],
			"Stern thruster": ["3 x 3700 kW"],
			"Deck dimensions": ["2700 m³"],
			"Deck strength": ["10 t/m² - 15 t/m²"],
			"Deck capacity": ["5000 t"],
			"Fuel oil": ["2650 m³"],
			"Pot water": ["800 m³"],
			"Methanol/special product": ["200 m³"],
			"Brine/Glycol": ["500 m³"],
			Moonpool: ["9.4 m x 7.2 m"],
			"ROV moonpool": ["2 x 5 m x 5.6 m"],
			"ROV hangar": ["321 m²"],
			"Deck crane": ["3 x SWL 6 t"],
			"Offshore crane": ["SWL 450/900 t", "4400/2200 m"],
			"Offshore crane II": ["SWL 150 t", "3000 m"],
			Laytower: ["650 t"],
		},
	},
	"Skandi Amazonas": {
		"Vessel built": "2011",
		"Vessel design": ["STX AH12"],
		"Class definition": [
			"✠ 1A1 Tug Supply Vessel SF COMF-V(3) E0 DYNPOS-AUTR NAUT-OSV(A) Clean(Design) DK(+) TMON",
		],
		"Length o.a.": "95.0 m",
		"Length b.p.": null,
		"Breadth mld": "24.1 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.8 m",
		"Scantling draft": null,
		Accommodation: "60",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 7680 kW"],
			"Bow thruster": ["2 x 1200 kW"],
			"Azimuth thruster": ["2 x 1500 kW"],
			"Stern thruster": ["1 x 1200 kW"],
			"Deck dimensions": ["750 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["3000 t"],
			"Fuel oil": ["1367 m³"],
			"Pot water": ["1077 m³"],
			"AH drum": ["2 x 460 t"],
			"Towing drum": ["1 x 500 t"],
			"Chain locker": ["1078 m³"],
			"Shark jaws": ["2 x 800 t"],
			"Towing pins": ["4 x 400 t"],
			"Deck crane": ["2 x SWL 5 t", "1 x SWL 15 t"],
			"Torpedo AH frame": ["Yes"],
		},
	},
	"Skandi Angra": {
		"Vessel built": "2015",
		"Vessel design": ["VARD AH11"],
		"Class definition": [
			"✠ 1A1 Supply vessel Tug Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 NAUT(OSV(A)) SF TMON",
		],
		"Length o.a.": "93.5 m",
		"Length b.p.": null,
		"Breadth mld": "22.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.9 m",
		"Scantling draft": null,
		Accommodation: "30",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 4500 kW", "2 x 4000 kW"],
			"Bow thruster": ["1 x 880 kW"],
			"Azimuth thruster": ["2 x 880 kW"],
			"Stern thruster": ["1 x 880 kW"],
			"Deck dimensions": ["760 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["1750 t"],
			"Fuel oil": ["1305 m³"],
			"Pot water": ["885 m³"],
			"Drill water": ["3240 m³"],
			"AH drum": ["1 x 500 t"],
			"Towing drum": ["2 x 460 t"],
			"Chain locker": ["1100 m³"],
			"Shark jaws": ["2 x 800 t"],
			"Towing pins": ["2 x 400 t"],
			"Deck crane": ["3 x SWL 5 t"],
			"Torpedo AH frame": ["Yes"],
		},
	},
	"Skandi Atlantic": {
		"Vessel built": "2012",
		"Vessel design": ["STX AH08"],
		"Class definition": [
			"✠ 1A1 Fire fighter(I+, II) Tug Clean(Design) DK(+) DYNPOS(AUTR) E0 HL(2.8) NAUT(OSV(A)) OILREC SF TMON",
		],
		"Length o.a.": "75.0 m",
		"Length b.p.": null,
		"Breadth mld": "17.4 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.0 m",
		"Scantling draft": null,
		Accommodation: "27",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 6000 kW"],
			"Bow thruster": ["2 x 880 kW"],
			"Stern thruster": ["2 x 880 kW"],
			"Deck dimensions": ["525 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["1000 t"],
			"Fuel oil": ["1685 m³"],
			"Pot water": ["641 m³"],
			"Dry bulk": ["264 m³"],
			Brine: ["430 m³"],
			"Drill water": ["2019 m³"],
			"AH drum": ["350 t"],
			"Towing drum": ["350 t"],
			"Chain locker": ["2 x 150 m³"],
			"Shark jaws": ["2 x 600 t"],
			"Towing pins": ["4 x 300 t"],
			"Deck crane": ["1 x SWL 5 t", "1 x SWL 3 t"],
		},
	},
	"Skandi Aukra": {
		"Vessel built": "2012",
		"Vessel design": ["STX PSV 09 CD"],
		"Class definition": [
			"✠ 1A1 Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) LFL(*) NAUT(OSV(A)) OILREC SF",
		],
		"Length o.a.": "87.9 m",
		"Length b.p.": null,
		"Breadth mld": "19.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.6 m",
		"Scantling draft": null,
		Accommodation: "26",
		"Service speed": null,
		Charterer: "Chrysaor",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1665 kW"],
			"Bow thruster": ["1 x 880 kW"],
			"Azimuth thruster": ["1 x 880 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["1000 m²"],
			"Deck strength": ["5 t/m² - 10 t/m²"],
			"Deck capacity": ["2600 t"],
			"*": [
				"Tank capacities are dependent on configuration of tank modes and maximum for each product (combined tanks).",
			],
			"Fuel oil": ["1052 m³"],
			Mud: ["962 m³"],
			"Pot water": ["1293 m³"],
			"Base oil": ["316 m³"],
			Methanol: ["127 m³"],
			"Dry bulk": ["320 m³"],
			"Drill water": ["2924 m³"],
			Brine: ["962 m³"],
			ORO: ["1356 m³"],
			Crane: ["SWL 1 t", "SWL 5 t"],
		},
	},
	"Skandi Barra": {
		"Vessel built": "2005",
		"Vessel design": ["MT 6000", "MK II"],
		"Class definition": ["✠ 1A1 Clean COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.5,2.8) LFL(*) SF"],
		"Length o.a.": "86.65 m",
		"Length b.p.": null,
		"Breadth mld": "19.7 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.18 m",
		"Scantling draft": null,
		Accommodation: "24",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1530 kW"],
			"Bow thruster": ["1 x 880 kW"],
			"Azimuth thruster": ["1 x 883 kW"],
			"Deck dimension": ["941 m²"],
			"Deck strength": ["5 t/m²"],
			"Deck capacity": ["3164 t"],
			"Fuel oil": ["1230 m³"],
			Mud: ["654 m³"],
			"Pot water": ["892 m³"],
			"Base oil": ["204 m³"],
			Methanol: ["162 m³"],
			"Dry bulk": ["396 m³"],
			"Drill water": ["1188 m³"],
			Brine: ["646 m³"],
			"Crane SWL": ["1 t", "SWL 3 t"],
		},
	},
	"Skandi Buzios": {
		"Vessel built": "2016",
		"Vessel design": ["VARD 3 05"],
		"Class definition": [
			"✠ 1A1 E0 DYNPOS-AUTR DK (+) CRANE HELDK-SH BIS Clean(Design) NAUT-AW Comf-V(3) C(3) SPS ICS SF",
		],
		"Length o.a.": "146.0 m",
		"Length b.p.": null,
		"Breadth mld": "30.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.5 m",
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["6 x 3840 kW"],
			"Bow thruster": ["3 x 2400 kW"],
			"Azimuth thruster": ["1 x 2000 kW"],
			"Stern thruster": ["3 x 3700 kW"],
			"Deck dimensions": ["3000 m²"],
			"Deck strength": ["10 t/m²"],
			"Fuel oil": ["2500 m³"],
			"Pot water": ["1800 m³"],
			"Chain locker": ["TBC"],
			Moonpool: ["9.1 m x 7.2m"],
			"Helideck dim": ["22 m diam"],
			"Deck crane": ["1 x SWL 5 t", "1 x SWL 10 t", "2 x SWL 15 t"],
			"Offshore crane": ["50 t SWL"],
			"Laytower (tiltable)": ["650 t"],
			Basket: ["1 x 2500 t", "1 x 1500 t"],
		},
	},
	"Skandi Caledonia": {
		"Vessel built": "2003",
		"Vessel design": ["MT 6000"],
		"Class definition": ["✠ 1A1 SF LFL* COMF-V(3) E0 DYNPOS-AUTR CLEAN DK(+) HL(2.0, 2.8)"],
		"Length o.a.": "83.9 m",
		"Length b.p.": null,
		"Breadth mld": "19.7 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.1 m",
		"Scantling draft": null,
		Accommodation: "24",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1530 kW"],
			"Bow thruster": ["1 x 883 kW"],
			"Azimuth thruster": ["1 x 883 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimensions": ["907 m²"],
			"Deck strength": ["5 t/m²"],
			"Deck capacity": ["3400 t"],
			"Fuel oil": ["1270 m³"],
			Mud: ["653 m³"],
			"Pot water": ["983 m³"],
			"Base oil": ["196 m³"],
			Methanol: ["163 m³"],
			"Dry bulk": ["397 m³"],
			"Drill water": ["1009 m³"],
			Brine: ["720 m³"],
			Crane: ["2 x SWL 3 t"],
		},
	},
	"Skandi Carla": {
		"Vessel built": "2001",
		"Vessel design": ["MT 6002"],
		"Class definition": ["✠ 1A1 SF HELDK E0 DYNPOS-AUTR CLEAN DK(+)"],
		"Length o.a.": "83.85 m",
		"Length b.p.": null,
		"Breadth mld": "19.7 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.1 m",
		"Scantling draft": null,
		Accommodation: "80",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 2530 kW"],
			"Bow thruster": ["2 x 1000 kW"],
			"Azimuth thruster": ["1 x 1000 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimensions": ["634 m² +", "total Mezz", "209 m²"],
			"Deck strength": ["5 t/m²"],
			"Deck capacity": ["820 t"],
			"Fuel oil": ["1448 m³"],
			"Pot water": ["851 m³"],
			"Drill water": ["1598 m³"],
			MEG: ["270 m³"],
			"Helideck dim": ["19.5 m diam", "9.3 t"],
			Moonpool: ["30 m²"],
			"ROV hangar": ["130 m²"],
			"Deck crane": ["SWL 3 t", "SWL 10 t"],
			"Offshore crane": ["SWL 50 t", "3105 m"],
		},
	},
	"Skandi Chieftain": {
		"Vessel built": "2005",
		"Vessel design": ["MT 6009"],
		"Class definition": ["✠ 1A1 SF COMF-V(3) E0 DYNPOS-AUTR CLEAN DK(+) HL(2.5)"],
		"Length o.a.": "74.3 m",
		"Length b.p.": null,
		"Breadth mld": "16.4 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.3 m",
		"Scantling draft": null,
		Accommodation: "50",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1150 kW"],
			"Bow thruster": ["2 x 800 kW"],
			"Azimuth thruster": ["2 x 1470 kW"],
			"Deck dimensions": ["260 m²"],
			"Deck strength": ["5 t/m²"],
			"Deck capacity": ["2030 t"],
			"Fuel oil": ["1200 m³"],
			"Pot water": ["651 m³"],
			"Drill water": ["912 m³"],
			"Base oil": ["347 m³"],
			Brine: ["424 m³"],
			Methanol: ["206 m³"],
			Mud: ["1083 m³"],
			"Deck crane": ["SWL 3 t", "SWL 1 t", "SWL 16 t"],
			"Offshore crane": ["SWL 16 t"],
			"A-frame": ["SWL 30 t"],
			"AHC winch": ["SWL 10 t"],
		},
	},
	"Skandi Commander": {
		"Vessel built": "2007",
		"Vessel design": ["MT 6009"],
		"Class definition": ["✠ 1A1 SF COMF-V(3) E0 DYNPOS-AUTR NAUT-OSV(A) CLEAN DK(+) HL(2.5)"],
		"Length o.a.": "74.3 m",
		"Length b.p.": null,
		"Breadth mld": "16.4 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.2 m",
		"Scantling draft": null,
		Accommodation: "48",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 1140 kW", "2 x 1330 kW"],
			"Bow thruster": ["2 x 1920 kW"],
			"Azimuth thruster": ["2 x 1470 kW"],
			"Deck dimensions": ["218 m³"],
			"Deck strength": ["5 t/m²"],
			"Deck capacity": ["1600 t"],
			"Fuel oil": ["1232 m³"],
			"Pot water": ["652 m³"],
			"Drill water": ["892 m³"],
			"Base oil": ["346 m³"],
			Brine: ["424 m³"],
			Methanol: ["206 m³"],
			Mud: ["1079 m³"],
			"Deck crane": ["SWL 1 t", "SWL 3 t"],
			"Offshore crane": ["SWL 10 t"],
			"A-frame": ["SWL 30 t"],
			"AHC winch": ["SWL 10 t"],
		},
	},
	"Skandi Darwin": {
		"Vessel built": "2012",
		"Vessel design": ["MT 6015", "MPSV"],
		"Class definition": [
			"✠ 1A1 E0 SF Dynpos AUTR CLEAN DESIGN COMF-V (rat. 3) DK(+) hl(2,5 LFL* NAUT OSV (A) Ice C SPS Oil Recovery",
		],
		"Length o.a.": "93.8 m",
		"Length b.p.": null,
		"Breadth mld": "20.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.5 m",
		"Scantling draft": null,
		Accommodation: "60",
		"Service speed": null,
		Charterer: "Esso Australia",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 2230 kW"],
			"Bow thrusters": ["2 x 925 kW"],
			"Azimuth thruster": ["1 x 880 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["760 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["1850 t"],
			"Fuel oil": ["1030 m³"],
			"Fresh water": ["1000 m³"],
			"Drill water": ["2100 m³"],
			Brine: ["790/1120 m³"],
			Methanol: ["194 m³"],
			"Dry bulk": ["330 m³"],
			Mud: ["1185/", "1515 m³"],
			"Deck crane": ["SWL 2 t", "SWL 3 t"],
			"Offshore crane": ["70 t"],
		},
	},
	"Skandi Emerald": {
		"Vessel built": "2011",
		"Vessel design": ["STX AH08"],
		"Class definition": [
			"✠ 1A1 Fire fighter(I+, II) Tug Clean(Design) DK(+) DYNPOS(AUTR) E0 HL(2.8) NAUT(OSV(A)) SF TMON",
		],
		"Length o.a.": "75.0 m",
		"Length b.p.": null,
		"Breadth mld": "17.4 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.0 m",
		"Scantling draft": null,
		Accommodation: "27",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 6000 kW"],
			"Bow thruster": ["2 x 880 kW"],
			"Stern thruster": ["2 x 880 kW"],
			"Deck dimensions": ["525 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["1000 t"],
			"Fuel oil": ["1685 m³"],
			"Pot water": ["641 m³"],
			"Dry bulk": ["264 m³"],
			Brine: ["430 m³"],
			"Drill water": ["2019 m³"],
			"AH drum": ["350 t"],
			"Towing drum": ["350 t"],
			"Chain locker": ["2 x 150 m³"],
			"Shark jaws": ["2 x 600 t"],
			"Towing pins": ["4 x 300 t"],
			"Deck crane": ["SWL 5 t", "SWL 3 t"],
		},
	},
	"Skandi Feistein": {
		"Vessel built": "2011",
		"Vessel design": ["STX", "PSV 09 CD"],
		"Class definition": [
			"✠ 1A1 Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) LFL(*) NAUT(OSV(A)) OILREC SF",
		],
		"Length o.a.": "87.9 m",
		"Length b.p.": null,
		"Breadth mld": "19.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.6 m",
		"Scantling draft": null,
		Accommodation: "26",
		"Service speed": null,
		Charterer: "Esso Australia",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1665 kW"],
			"Bow thruster": ["1 x 880 kW"],
			"Azimuth thruster": ["1 x 880 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["1000 m²"],
			"Deck strength": ["5 t/m² - 10", "t/m²"],
			"Deck capacity": ["2600 t"],
			"Fuel oil": ["858 m³"],
			Mud: ["795 m³"],
			"Pot water": ["720 m³"],
			"Base oil": ["189 m³"],
			Methanol: ["167 m³"],
			"Dry bulk": ["325 m³"],
			"Drill water": ["1924 m³"],
			Brine: ["187 m³"],
			Crane: ["SWL 1 t", "SWL 5 t"],
		},
	},
	"Skandi Flora": {
		"Vessel built": "2009",
		"Vessel design": ["STX", "PSV 06 CD"],
		"Class definition": [
			"✠ 1A1 Supply vessel Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) LFL(*) OILREC SF",
		],
		"Length o.a.": "94.9 m",
		"Length b.p.": null,
		"Breadth mld": "20.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.53 m",
		"Scantling draft": null,
		Accommodation: "25",
		"Service speed": null,
		Charterer: "Equinor",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1 980 kW"],
			"Bow thruster": ["2 x 880 kW"],
			"Azimuth thruster": ["1 x 880 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["1025 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["3200 t"],
			"Fuel oil": ["900 m³"],
			Mud: ["1506 m³"],
			"Pot water": ["851 m³"],
			"Base oil": ["266 m³"],
			Methanol: ["230 m³"],
			"Dry bulk": ["404 m³"],
			"Drill water": ["1980 m³"],
			Brine: ["1506 m³"],
			Crane: ["2 x SWL 10 t"],
			"NOFO compliant": ["Yes"],
		},
	},
	"Skandi Fluminense": {
		"Vessel built": "2007",
		"Vessel design": ["UT 722 L"],
		"Class definition": [
			"✠ 1A1 Tug Supply Vessel Fire Fighter I+ and II OILREC SF COMF-V(3) E0 DYNPOS-AUTR CLEAN TMON",
		],
		"Length o.a.": "80.5 m",
		"Length b.p.": null,
		"Breadth mld": "18.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.0 m",
		"Scantling draft": null,
		Accommodation: "40",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 3560 kW", "2 x 2650 kW"],
			"Bow thruster": ["1 x 883 kW"],
			"Azimuth thruster": ["1 x 1120 kW"],
			"Stern thruster": ["2 x 736 kW"],
			"Deck dimensions": ["590 m²"],
			"Deck strength": ["5 t/m² - 10 t/m²"],
			"Deck capacity": ["800 t"],
			"Fuel oil": ["1126 m³"],
			"Pot water": ["641 m³"],
			"Base oil": ["193 m³"],
			Mud: ["468 m³"],
			"Dry bulk": ["334 m³"],
			Brine: ["850 m³"],
			"Drill water": ["1467 m³"],
			"AH drum": ["500 t"],
			"Towing drum": ["400 t"],
			"Chain locker": ["570 m³"],
			"Shark jaws": ["2 x 700 t"],
			"Towing pins": ["4 x 300 t"],
			"Deck crane": ["SWL 10 t", "SWL 2 t"],
		},
	},
	"Skandi Gamma": {
		"Vessel built": "2011",
		"Vessel design": ["STX", "PSV 06 LNG"],
		"Class definition": [
			"✠ 1A1 Standby Vessel OILREC SF LFL* COMF-V(3)C(3) E0 ESV-DP[HIL] DYNPOS-AUTR NAUT-OSV(A) Clean(Design) DK(+) HL(2.8) GAS FUELLED",
		],
		"Length o.a.": "94.9 m",
		"Length b.p.": null,
		"Breadth mld": "20.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.6 m",
		"Scantling draft": null,
		Accommodation: "25",
		"Service speed": null,
		Charterer: "Ithaca Energy",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["3 x 2610 kW"],
			"Bow thruster": ["2 x 883 kW"],
			"Azimuth thruster": ["1 x 880 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["1000 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["3000 t"],
			"*": [
				"The vessel has a Multi- Application",
				"Cargo System (PG MACS) Tank",
				"capacities are dependent on",
				"configuration of tank modes",
				"and maximum for each product",
				"(combined tanks).",
			],
			"Multi-purp. tank (Mud/Brine/Cement/ORO)": ["1172 m³"],
			"Fuel Oil": ["1290 m³"],
			LNG: ["205 m³"],
			"Drill cuttings": ["525 m³"],
			"Pot water": ["881 m³"],
			"Base oil": ["200 m³"],
			Methanol: ["231 m³"],
			"Special product": ["200 m³"],
			"Drill water": ["1908 m³"],
			Brine: ["220 m³"],
			ORO: ["1700 m³"],
			Crane: ["SWL 3 t", "SWL 10 t"],
			"NOFO compliant": ["Yes"],
		},
	},
	"Skandi Hawk": {
		"Vessel built": "2012",
		"Vessel design": ["STX", "PSV 09 CD"],
		"Class definition": [
			"✠ 1A1 Fire fighter(I) Supply vessel Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) LFL(*) NAUT(OSV(A)) SF",
		],
		"Length o.a.": "88.1 m",
		"Length b.p.": null,
		"Breadth mld": "19.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.6 m",
		"Scantling draft": null,
		Accommodation: "62",
		"Service speed": null,
		Charterer: "Prime Energy Resources Development B.V.",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1665 kW"],
			"Bow thruster": ["1 x 880 kW"],
			"Azimuth thruster": ["1 x 880 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["730 m²"],
			"Deck strength": ["5 - 10 t/m²"],
			"Deck capacity": ["2450 t"],
			"Fuel oil": ["1054 m³"],
			"Pot water": ["533 m³"],
			"Drill water": ["2166 m³"],
			"Base oil": ["192 m³"],
			Brine: ["960 m³"],
			Methanol: ["208 m³"],
			"Dry bulk": ["320 m³"],
			Mud: ["970 m³"],
			"Deck crane": ["SWL 1 t", "SWL 5 t"],
			"Offshore crane": ["SWL 60 t", "2000 m"],
		},
	},
	"Skandi Hera": {
		"Vessel built": "2009",
		"Vessel design": ["Ulstein A122"],
		"Class definition": [
			"✠ 1A1 ICE-C Tug Supply Vessel SF COMF-V(3)C(3) OPP-F E0 DYNPOS-AUTR NAUT-OSV(A) CLEAN DESIGN DK(+) HL(2.5)",
		],
		"Length o.a.": "93.8 m",
		"Length b.p.": null,
		"Breadth mld": "23.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.0 m",
		"Scantling draft": null,
		Accommodation: "68",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 4500 kW"],
			"Bow thruster": ["2 x 1200 kW"],
			"Azimuth thruster": ["1 x 1400 kW"],
			"Stern thruster": ["2 x 1050 kW"],
			"Deck dimensions": ["721 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["2500 t"],
			"Fuel oil": ["1800 m³"],
			"Ballast water": ["4771 m³"],
			"Base oil": ["190 m³"],
			Mud: ["639 m³"],
			Cement: ["175 m³"],
			Brine: ["964 m³"],
			"Fresh water": ["706 m³"],
			"Special-handling drum": ["500 t"],
			"Towing & AH drum": ["2 x 450 t"],
			"Chain locker": ["4 x 200 m³"],
			"Shark jaws": ["2 x 800 t"],
			"Towing pins": ["4 x 300 t"],
			"Offshore crane prepared for": ["250 t"],
			"Deck crane": ["1 x SWL 25 t", "2 x SWL 5 t"],
		},
	},
	"Skandi Hercules": {
		"Vessel built": "2010",
		"Vessel design": ["STX, AH04 CD"],
		"Class definition": [
			"✠ 1A1 Tug Supply Vessel SF COMF-V(3) HELDK-SH E0 DYNPOS-AUTR NAUT-OSV(A) Clean(Design) DK(+) HL(2.8) TMON",
		],
		"Length o.a.": "109.6 m",
		"Length b.p.": null,
		"Breadth mld": "24.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.8 m",
		"Scantling draft": null,
		Accommodation: "90",
		"Service speed": null,
		Charterer: "DOF Subsea APAC",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 7680 kW", "4 x 2600 kW"],
			"Bow thruster": ["2 x 1500 kW"],
			"Azimuth thruster": ["1 x 1500 kW"],
			"Stern thruster": ["2 x 1200 kW"],
			"Deck dimension": ["970 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["2800 t"],
			"Fuel oil": ["2416 m³"],
			"Pot water": ["965 m³"],
			"Helideck dim": ["20.88 m", "diam, 12.8 t"],
			Moonpool: ["7.2 x 7.2 m"],
			"ROV hangar": ["68 m²"],
			"Deck crane": ["2 x SWL 3 t", "2 x SWL 5 t"],
			"Offshore crane": ["SWL 250 t", "3000 m"],
			"AH drum": ["1 x 500 t"],
			"Towing drum": ["2 x 500 t"],
			"Chain locker": ["4 x 299 m³"],
			"Shark jaws": ["3 x 800 t"],
			"Towing pins": ["4 x 300 t"],
		},
	},
	"Skandi Hugen": {
		"Vessel built": "2013",
		"Vessel design": ["STX", "MRV 05 ROV"],
		"Class definition": [
			"✠ 1A1 Offshore service vessel SPS Standby vessel Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) NAUT(OSV(A)) OILREC SF",
		],
		"Length o.a.": "82.2 m",
		"Length b.p.": null,
		"Breadth mld": "17.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.1 m",
		"Scantling draft": null,
		Accommodation: "46",
		"Service speed": null,
		Charterer: "ConocoPhillips",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 2600 kW", "1 x 1665 kW"],
			"Bow thruster": ["2 x 880 kW"],
			"Azimuth thruster": ["1 x 1200 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["570 m²"],
			"Deck strength": ["5 - 10 t/m²"],
			"Deck capacity": ["2600 t"],
			"Fuel oil": ["857 m³"],
			Mud: ["594 m³"],
			"Pot water": ["1123 m³"],
			"Base oil": ["415 m³"],
			"Dry bulk": ["305 m³"],
			"Drill water": ["1383 m³"],
			Brine: ["270 m³"],
			ORO: ["1604 m³"],
			"Offshore crane": ["SWL 15 t", "220 m"],
			"Offshore crane II": ["SWL 15 t", "220 m"],
			"NOFO compliant": ["Yes"],
		},
	},
	"Skandi Iceman": {
		"Vessel built": "2013",
		"Vessel design": ["VARD AH12"],
		"Class definition": [
			"✠ 1A1 Fire fighter(I, II) Offshore service vessel(AHTS) SPS Clean(Design) COMF(C-3, V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) Ice(1B) NAUT(OSV(A)) OILREC Recyclable SF TMON Winterized(Basic)",
		],
		"Length o.a.": "93.5 m",
		"Length b.p.": null,
		"Breadth mld": "24.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.5 m",
		"Scantling draft": null,
		Accommodation: "45",
		"Service speed": null,
		Charterer: "Equinor",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 6000 kW", "3 x 2850 kW"],
			"Bow thruster": ["2 x 1200 kW"],
			"Azimuth thruster": ["1 x 1200 kW"],
			"Stern thruster": ["2 x 1200 kW"],
			"Deck dimensions": ["780 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["appr. 2300 t"],
			"Fuel oil": ["1429 m³", "(combined tanks 2047 m³)"],
			"Pot water": ["845 m³"],
			Mud: ["618 m³"],
			"Dry bulk": ["250 m³"],
			Brine: ["618 m³"],
			"Drill water": ["3462 m³"],
			"AH drum": ["500 t"],
			"Towing drum": ["1 x 500 t", "1 x 450 t"],
			"Chain lockers": ["4 x 250 m³"],
			"Shark jaws": ["2 x 600 t"],
			"Towing pins": ["2 x 400 t"],
			"Deck crane": ["2 x SWL 5 t", "1 x SWL 12 t"],
			"A-frame": ["SWL 300 t"],
			"NOFO compliant": ["Yes (2009)"],
			"GMDSS zone": ["A4"],
		},
	},
	"Skandi Iguacu": {
		"Vessel built": "2012",
		"Vessel design": ["STX AH12"],
		"Class definition": [
			"✠ 1A1 Supply vessel Tug Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 NAUT(OSV(A)) SF TMON",
		],
		"Length o.a.": "95.0 m",
		"Length b.p.": null,
		"Breadth mld": "24.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.8 m",
		"Scantling draft": null,
		Accommodation: "60",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 7680 kW"],
			"Bow thruster": ["2 x 1200 kW"],
			"Azimuth thruster": ["2 x 1500 kW"],
			"Stern thruster": ["1 x 1200 kW"],
			"Deck dimensions": ["750 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["3000 t"],
			"Fuel oil": ["1367 m³"],
			"Pot water": ["1077 m³"],
			"AH drum": ["2 x 460 t"],
			"Towing drum": ["1 x 500 t"],
			"Chain locker": ["1078 m³"],
			"Shark jaws": ["2 x 800 t"],
			"Towing pins": ["2 x 400 t"],
			"Deck crane": ["2 x SWL 5 t", "1 x SWL 15 t"],
			"Torpedo AH frame": ["Yes"],
		},
	},
	"Skandi Ipanema": {
		"Vessel built": "2010",
		"Vessel design": ["STX AH05"],
		"Class definition": ["✠ 1A1 Fire fighter(I) Tug DK(+) DYNPOS(AUT) E0 SF TMON"],
		"Length o.a.": "74.3 m",
		"Length b.p.": null,
		"Breadth mld": "17.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.0 m",
		"Scantling draft": null,
		Accommodation: "38",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 4500 kW"],
			"Bow thruster": ["1 x 880 kW"],
			"Azimuth thruster": ["1 x 905 kW"],
			"Stern thruster": ["1 x 880 kW"],
			"Deck dimensions": ["654 m²"],
			"Deck strength": ["7.5 t/m²-10 t/m²"],
			"Deck capacity": ["1000 t"],
			"Fuel oil": ["850 m³"],
			"Pot water": ["741 m³"],
			"Dry bulk": ["216 m³"],
			Brine: ["549 m³"],
			"Base oil": ["266 m³"],
			"Drill water": ["660 m³"],
			"AH drum": ["310 t"],
			"Towing drum": ["310 t"],
			"Chain locker": ["2 x 139 m³"],
			"Shark jaws": ["2 x Karmoy"],
			"Towing pins": ["4 x Karmoy", "350 mm", "270 t SWL"],
			"Deck crane": ["1 x SWL 5 t", "1 x SWL", "1.5 t"],
		},
	},
	"Skandi Installer": {
		"Vessel built": "2017",
		"Vessel design": ["Marin Teknikk", "6027"],
		"Class definition": [
			"✠ A1, Offshore Support Vessel, Supply, AMS, ACCU, DPS3, FFV 1, WS-Ready, NIBS, HELIDK, BWE, UWILD, HDC 10 t/m2 aft of Frame 126, SC, R2, TCM, ENVIRO, PMP+, CRC, SPS, Ice Class IC 2824KW",
		],
		"Length o.a.": "137.6 m",
		"Length b.p.": null,
		"Breadth mld": "27.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.0 m",
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Hybrid propulsion", "TBA kW"],
			"Bow thruster": ["3 x 2750 kW"],
			"Stern thruster": ["3 x 2000 kW"],
			"Deck dimension": ["1925 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["TBA t"],
			"Fuel oil": ["2332 m³"],
			"Pot water": ["1042 m³"],
			"Drill water": ["7291 m³"],
			Moonpool: ["1 x 8.4x8.4 m", "1 x 4.8x4.8 m"],
			"Offshore crane": ["400 t @ 3000 m", "water depth"],
			"Offshore crane II": ["100 t @ 3000 m", "water depth"],
			"Pipe laying capability": [
				"Prepared for under deck carousel",
				"of 3000 t product, and ready",
				"for 275t vertical lay tower for",
				"deployment of flexible pipe or",
				"module handling",
			],
		},
	},
	"Skandi Inventor": {
		"Vessel built": "2018",
		"Vessel design": ["Marin Teknikk", "6027"],
		"Class definition": [
			"✠ A1, Offshore Support Vessel, Supply, AMS, ACCU, DPS3, FFV 1, WS-Ready, NIBS, HELIDK, BWE, UWILD, HDC 10 t/m2 aft of Frame 126, SC, R2, TCM, ENVIRO, PMP+, CRC, SPS, Ice Class IC 2824KW",
		],
		"Length o.a.": "137.6 m",
		"Length b.p.": null,
		"Breadth mld": "27.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.0 m",
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Hybrid propulsion", "TBA kW"],
			"Bow thruster": ["3 x 2750 kW"],
			"Stern thruster": ["3 x 2000 kW"],
			"Deck dimension": ["1925 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["TBA t"],
			"Fuel oil": ["2332 m³"],
			"Pot water": ["1042 m³"],
			"Drill water": ["7291 m³"],
			Moonpool: ["1 x 8.4x8.4 m", "1 x 4.8x4.8 m"],
			"Offshore crane": ["400 t @ 3000 m", "water depth"],
			"Offshore crane II": ["100 t @ 3000 m", "water depth"],
			"Pipe laying capability": [
				"Prepared for under deck carousel",
				"of 3000 t product, and ready",
				"for 275t vertical lay tower for",
				"deployment of flexible pipe or",
				"module handling",
			],
		},
	},
	"Skandi Kvitsøy": {
		"Vessel built": "2012",
		"Vessel design": ["STX", "PSV 09 CD"],
		"Class definition": [
			"✠ 1A1 Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) LFL(*) NAUT(OSV(A)) OILREC SF",
		],
		"Length o.a.": "87.9 m",
		"Length b.p.": null,
		"Breadth mld": "19.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.6 m",
		"Scantling draft": null,
		Accommodation: "26",
		"Service speed": null,
		Charterer: "Esso Australia",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 2095 kW"],
			"Bow thruster": ["2 x 880 kW"],
			"Azimuth thruster": ["1 x 880 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["950 m²"],
			"Deck strength": ["5 t/m² - 10 t/m²"],
			"Deck capacity": ["2600 t"],
			"Fuel oil": ["1054 m³"],
			Mud: ["980 m³"],
			"Pot water": ["1002 m³"],
			"Base oil": ["189 m³"],
			Methanol: ["167 m³"],
			"Dry bulk": ["325 m³"],
			"Drill water": ["2836 m³"],
			Brine: ["980 m³"],
			Crane: ["SWL 1 t", "SWL 5 t"],
			"NOFO compliant": ["Yes"],
		},
	},
	"Skandi Marøy": {
		"Vessel built": "2012",
		"Vessel design": ["STX", "MRV 05 CD"],
		"Class definition": [
			"✠ 1A1 Fire fighter(I, II) Offshore service vessel Standby vessel Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) NAUT(OSV(A)) OILREC SF",
		],
		"Length o.a.": "82.2 m",
		"Length b.p.": null,
		"Breadth mld": "17.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.3 m",
		"Scantling draft": null,
		Accommodation: "28",
		"Service speed": null,
		Charterer: "ConocoPhillips",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 2600 kW", "1 x 1665 kW"],
			"Bow thruster": ["2 x 880 kW"],
			"Azimuth thruster": ["1 x 1200 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["600 m²"],
			"Deck strength": ["5 - 10 t/m²"],
			"Deck capacity": ["1650 t"],
			"Fuel oil": ["1145 m³"],
			Mud: ["537 m³"],
			"Pot water": ["897 m³"],
			"Base oil": ["276 m³"],
			"Dry bulk": ["304 m³"],
			"Drill water": ["1533 m³"],
			Brine: ["275 m³"],
			Crane: ["SWL 2 t", "SWL 3 t"],
			ORO: ["1547 m³"],
			"NOFO compliant": ["Yes"],
		},
	},
	"Skandi Minder": {
		"Vessel built": "2018",
		"Vessel design": ["Salt Ship Design 200"],
		"Class definition": [
			"✠ A1, Offshore Support Vessel, Supply, TOW, AH, AMS, ACCU, DPS-2, FFV 1, OSR-C1, SSR GR A 300 HDC, Ice Class IC 4931 kW, UWILD, ENVIRO, SPS, IHM, TCM, PMP+, HLC",
		],
		"Length o.a.": "95.0 m",
		"Length b.p.": null,
		"Breadth mld": "25.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.7 m",
		"Scantling draft": null,
		Accommodation: "52",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2x3880 kW", "2x3230 ekW", "1x1580 ekW"],
			"Bow thruster": ["3 x 1200 kW"],
			"Stern thruster": ["2 x 1200 kW"],
			"Deck dimensions": ["924 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["2500 t"],
			"Fuel oil": ["2608 m³"],
			"Dry bulk": ["310 m³"],
			Brine: ["1553 m³"],
			"Drill water": ["3510 m³"],
			"AH drum": ["450 t"],
			"Towing drum": ["2 x 500 t"],
			"Chain locker": ["2 x 286 m³", "2 x 322 m³"],
			"Shark jaws": ["2 x 700 t"],
			"Towing pins": ["2 x 300 t"],
			"Deck crane": ["2 x 2 t", "1 SWL x 42 t"],
		},
	},
	"Skandi Mobiliser": {
		"Vessel built": "2018",
		"Vessel design": ["Salt Ship Design 200"],
		"Class definition": [
			"✠ A1, Offshore Support Vessel, Supply, TOW, AH, AMS, ACCU, DPS-2, FFV 1, OSR-C1, SSR GR A 300 HDC, Ice Class IC 4931 kW, UWILD, ENVIRO, SPS, IHM, TCM, PMP+, HLC",
		],
		"Length o.a.": "95.0 m",
		"Length b.p.": null,
		"Breadth mld": "25.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.7 m",
		"Scantling draft": null,
		Accommodation: "52",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2x3880 kW", "2x3230 ekW", "1x1580 ekW"],
			"Bow thruster": ["3 x 1200 kW"],
			"Stern thruster": ["2 x 1200 kW"],
			"Deck dimensions": ["924 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["2500 t"],
			"Fuel oil": ["2608 m³"],
			"Dry bulk": ["310 m³"],
			Brine: ["1553 m³"],
			"Drill water": ["3510 m³"],
			"AH drum": ["450 t"],
			"Towing drum": ["2 x 500 t"],
			"Chain locker": ["2 x 286 m³", "2 x 322 m³"],
			"Shark jaws": ["2 x 700 t"],
			"Towing pins": ["2 x 300 t"],
			"Deck crane": ["2 x 2 t", "1 SWL x 42 t"],
		},
	},
	"Skandi Mongstad": {
		"Vessel built": "2008",
		"Vessel design": ["Vik-Sandvik", "PSV 495", "DEM"],
		"Class definition": [
			"✠ 1A1 Tug Supply Vessel Standby Vessel(S) Fire Fighter II OILREC SF LFL* COMF-V(3)C(3) E0 DYNPOS-AUTR Clean(Design) DK(+) HL(2.8) TMON",
		],
		"Length o.a.": "96.9 m",
		"Length b.p.": null,
		"Breadth mld": "21.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.0 m",
		"Scantling draft": null,
		Accommodation: "24",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 1600 kW"],
			"Bow thruster": ["2 x 883 kW"],
			"Azimuth thruster": ["3 x 1200 kW"],
			"Stern thruster": ["1 x 590 kW"],
			"Deck dimension": ["1176 m²"],
			"Deck strength": ["10 m²"],
			"Deck capacity": ["3400 t"],
			"Fuel oil": ["1167 m³"],
			Mud: ["876.5 m³"],
			"Pot water": ["892 m³"],
			"Base oil": ["220 m³"],
			Methanol: ["203 m³"],
			"Dry bulk": ["366 m³"],
			"Drill water": ["2587 m³"],
			Brine: ["477 m³"],
			Crane: ["2 x SWL 10 t"],
			"NOFO compliant Standard": ["2005"],
		},
	},
	"Skandi Niterói": {
		"Vessel built": "2011",
		"Vessel design": ["STX", "OSCV 06"],
		"Class definition": [
			"✠ 1A1 Clean(Design) COMF(C-3, V-3) Crane DK(+) DYNPOS(AUTRO) E0 HELDK(S, H) SF",
		],
		"Length o.a.": "142.2 m",
		"Length b.p.": null,
		"Breadth mld": "27.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.5 m",
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 3840 kW", "4 x 2 880 kW"],
			"Bow thruster": ["2 x 1900 kW"],
			"Azimuth thruster": ["2 x 1500 kW"],
			"Stern thruster": ["2 x 3700 kW"],
			"Deck dimension": ["2100 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["1725 t"],
			"Fuel oil": ["2219 m³"],
			"Pot water": ["1849 m³"],
			"Helideck dim": ["21 m diam,", "Sikorsky-92 compatible"],
			Moonpool: ["7.2 m x 7.2 m"],
			"ROV hangar": ["2 x TRITON", "XLX Vehicles", "Total Area = 243 m²"],
			"Deck crane": ["3 x SWL 3 t"],
			"Offshore crane": ["SWL 250 t", "2500 m"],
			"Offshore crane II": ["SWL 50/100 t", "2000 m"],
			Tower: ["OSLT 270 t", "VLS"],
		},
	},
	"Skandi Nova": {
		"Vessel built": "2012",
		"Vessel design": ["STX", "MRV 05 SP"],
		"Class definition": [
			"✠ 1A1 Fire fighter(I, II) Offshore service vessel SPS Standby vessel Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) NAUT(OSV(A)) SF",
		],
		"Length o.a.": "82.2 m",
		"Length b.p.": null,
		"Breadth mld": "17.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.1 m",
		"Scantling draft": null,
		Accommodation: "46",
		"Service speed": null,
		Charterer: "ConocoPhillips",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 2600 kW", "1 x 1665 kW"],
			"Bow thruster": ["2 x 880 kW"],
			"Azimuth thruster": ["1 x 1200 kW"],
			"Stern thruster": ["2 x 2200 kW"],
			"Deck dimension": ["600 m²"],
			"Deck strength": ["5 t/m²"],
			"Deck capacity": ["1150 t"],
			"Fuel oil": ["857 m³"],
			Mud: ["594 m³"],
			"Pot water": ["1116 m³"],
			"Base oil": ["415 m³"],
			"Dry bulk": ["302 m³"],
			"Drill water": ["1490 m³"],
			Brine: ["270 m³"],
			Crane: ["SWL 2 t", "SWL 3 t"],
		},
	},
	"Skandi Olinda": {
		"Vessel built": "2019",
		"Vessel design": ["VARD 3 16"],
		"Class definition": [
			"✠ 1A1 E0 DYNPOS-AUTR DK (+) CRANE HELDK-SH BIS Clean(Design) NAUT-AW Comf-V(3) C(3) SPS ICS SF",
		],
		"Length o.a.": "139.9 m",
		"Length b.p.": null,
		"Breadth mld": "28.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.5 m",
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["6 x 2880 kW"],
			"Bow thruster": ["2 x 2000 kW"],
			"Azimuth thruster": ["2 x 1800 kW"],
			"Stern thruster": ["2 x 3700 kW"],
			"Deck dimensions": ["1800 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["TBA"],
			"Fuel oil": ["1700 m³"],
			"Pot water": ["1200 m³"],
			Moonpool: ["7.2 m x 7.2 m"],
			Helideck: ["dim 22 m diam"],
			"Deck crane": ["3 x SWL 3 t", "1 x SWL 50 t"],
			"Offshore crane": ["50 t", "@ 3000 m water depth"],
			Laytower: [
				"340t tension",
				"fold-able tower, 48m min hight",
				"ab sea level, approx 60m max",
				"height. Tower: 2x fully open type",
				"tensioners, remotely operated",
				"alligner wheel and end handling",
				"system. 380t A&R winch,",
				"3000m water depth rated.",
				"Product capacity; 3x200t reels",
				"on deck + 2500t basket below",
				"deck.",
			],
		},
	},
	"Skandi Olympia": {
		"Vessel built": "2009",
		"Vessel design": ["MT 6009 L"],
		"Class definition": ["✠ 1A1 Clean COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.5) NAUT(OSV(A)) SF"],
		"Length o.a.": "79.6 m",
		"Length b.p.": null,
		"Breadth mld": "16.4 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.2 m",
		"Scantling draft": null,
		Accommodation: "44",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 1424 kW"],
			"Bow thruster": ["2 x 800 kW"],
			"Azimuth thruster": ["2 x 1470 kW"],
			"Deck dimension": ["718 m²"],
			"Deck strength": ["5 t/m²"],
			"Deck capacity": ["1600 t"],
			"Fuel oil": ["1212 m³"],
			"Pot water": ["648 m³"],
			"Drill water": ["665 m³"],
			"Base oil": ["143 m³"],
			Brine: ["424 m³"],
			Methanol: ["205 m³"],
			"Dry bulk": ["320 m³", "5 x 64 m³"],
			"Deck crane": ["SWL 1.5 t", "SWL 3 t"],
		},
	},
	"Skandi Paraty": {
		"Vessel built": "2016",
		"Vessel design": ["VARD AH11"],
		"Class definition": [
			"✠ 1A1 SF SUPPLY VESSEL TUG E0 DYNPOS-AUTR COMF-V(3) Clean(Design) NAUT-OSV (T) DK(+) TMON",
		],
		"Length o.a.": "93.5 m",
		"Length b.p.": null,
		"Breadth mld": "22.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.9 m",
		"Scantling draft": null,
		Accommodation: "46",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 4500 kW", "2 x 4000 kW"],
			"Bow thruster": ["1 x 880 kW"],
			"Azimuth thruster": ["2 x 880 kW"],
			"Stern thruster": ["1 x 880 kW"],
			"Deck dimensions": ["760 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["TBA"],
			"Fuel oil": ["1305 m³"],
			"Pot water": ["870 m³"],
			"Drill water": ["3240 m³"],
			"AH drum": ["500 t"],
			"Towing drum": ["460 t"],
			"Chain locker": ["1100 m³"],
			"Shark jaws": ["2 x 800 t"],
			"Towing pins": ["2 x TBA"],
			"ROV hangar": ["Yes"],
			"Deck crane": ["3 x SWL 5 t"],
			"Torpedo AH frame": ["Yes"],
		},
	},
	"Skandi Patagonia": {
		"Vessel built": "2000",
		"Vessel design": ["MT 6016"],
		"Class definition": [
			"✠ 1A1 DSV(III) Fire fighter(I) Tug DK(+) DYNPOS(AUTR) E0 HELDK HL(2.8) SF",
		],
		"Length o.a.": "93.3 m",
		"Length b.p.": null,
		"Breadth mld": "19.7 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.09 m",
		"Scantling draft": null,
		Accommodation: "59",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: "UniSea",
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 1537 kW", "2 x 3655 kW"],
			"Stern thruster": ["2 x 3700 kW"],
			"Bow thruster": ["2 x 883 kW"],
			"Azimuth thruster": ["1 x 880 kW"],
			"Deck dimension": ["560 m²"],
			"Deck strength": ["5 t/m²"],
			"Deck capacity": ["2815 t"],
			"Fuel oil": ["1657 m³"],
			"Pot water": ["1012 m³"],
			"Drill water": ["1296 m³"],
			Brine: ["500 m³"],
			Mud: ["161 m³"],
			ORO: ["1100 m³"],
			"Helideck dim": ["14.3 m diam"],
			Moonpool: ["3.5 x 3.6 m"],
			"ROV hangar": ["108 m³"],
			"Deck crane": ["SWL 4 t", "SWL 5 t"],
			"Offshore crane": ["SWL 50 t", "1540 m"],
			"Diving bell": ["200 m, 3 pers"],
			"AH drum": ["200 t"],
			Towing: ["drum 200 t"],
			"Chain locker": ["2 x 44 m³"],
			"Shark jaws": ["1 x 350 t"],
			"Towing pins": ["1 x 240 t"],
		},
	},
	"Skandi Recife": {
		"Vessel built": "2018",
		"Vessel design": ["VARD 3 16"],
		"Class definition": [
			"✠ 1A1 E0 DYNPOS-AUTR DK (+) CRANE HELDK-SH BIS Clean(Design) NAUT-AW Comf-V(3) C(3) SPS ICS SF",
		],
		"Length o.a.": "139.9 m",
		"Length b.p.": null,
		"Breadth mld": "28.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "8.5 m",
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["6 x 2880 kW"],
			"Bow thruster": ["2 x 2000 kW"],
			"Azimuth thruster": ["2 x 1800 kW"],
			"Stern thruster": ["2 x 3700 kW"],
			"Deck dimensions": ["1800 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["N/A"],
			"Fuel oil": ["1700 m³"],
			"Pot water": ["1200 m³"],
			Moonpool: ["7.2 m x 7.2 m"],
			"Helideck dim": ["22 m diam"],
			"Deck crane": ["3 x SWL 3 t", "1 x SWL 50 t"],
			"Offshore crane": ["50 t", "@ 3000 m water depth"],
			Laytower: [
				"340t tension,",
				"fold-able tower, 48m min hight",
				"ab sea level, approx 60m max",
				"height. Tower: 2x fully open type",
				"tensioners, remotely operated",
				"alligner wheel and end handling",
				"system. 380t A&R winch,",
				"3000m water depth rated.",
				"Product capacity; 3x200t reels",
				"on deck + 2500t basket below",
				"deck.",
			],
		},
	},
	"Skandi Salvador": {
		"Vessel built": "2009",
		"Vessel design": ["STX ROV06"],
		"Class definition": [
			"✠ 1A1 ICE-C Fire Fighter II SF LFL* COMF-V(3) HELDK E0 DYNPOS-AUTR DK(+) HL(2.8)",
		],
		"Length o.a.": "105.9 m",
		"Length b.p.": null,
		"Breadth mld": "21.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.6 m max",
		"Scantling draft": null,
		Accommodation: "100",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 2780 kW"],
			"Bow thruster": ["2 x 1500 kW"],
			"Azimuth thruster": ["1 x 1500 kW"],
			"Main propulsion": ["2 x 3000 kW"],
			"Deck dimension": ["1000 m²"],
			"Deck strength": ["5 t/m² - 10 t/m²"],
			"Deck capacity": ["1200 t"],
			"Fuel oil": ["1292 m³"],
			"Pot water": ["628 m³"],
			"Drill water": ["3682 m³"],
			"Base oil": ["235 m³"],
			Brine: ["467 m³"],
			Mud: ["600 m³"],
			Ethanol: ["150 m³"],
			"Dry bulk": ["256 m³"],
			"Helideck dim": ["21 m diam,", "Sikorsky-92 compatible"],
			Moonpool: ["7.2 x 7.2 m"],
			"ROV hangar": ["168 m²"],
			"Deck crane": ["1 x SWL 3 t", "1 x SWL 25 t"],
			"Offshore crane": ["SWL 140 t", "2545 m"],
			"Offshore AHC Winch": ["SWL 250 t"],
		},
	},
	"Skandi Seven": {
		"Vessel built": "2008",
		"Vessel design": ["STX", "OSCV 03"],
		"Class definition": [
			"✠ 1A1 Clean(Design) COMF(C-3, V-3) Crane DK(+) DYNPOS(AUTRO) E0 HELDK(S, H) Ice(C) NAUT(AW) SF",
		],
		"Length o.a.": "120.7 m",
		"Length b.p.": null,
		"Breadth mld": "23.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.0 m",
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "DOF Subsea Norway",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 2880 kW"],
			"Bow thruster": ["2 x 1500 kW"],
			"Azimuth thruster": ["2 x 1900 kW"],
			"Stern thruster": ["2 x 3000 kW"],
			"Deck dimensions": ["1300 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["3150 t"],
			"Fuel oil": ["1864 m³"],
			"Pot water": ["796 m³"],
			"Helideck dim": ["20.9 m diam", "12.8 t"],
			Moonpool: ["(7.2 x 7.2 m)", "+ (5.5 x 5.5 m)"],
			"ROV hangar": ["208 m²"],
			"Deck crane": ["2 x SWL 3 t"],
			"Offshore crane": ["SWL 250 t", "2500 m"],
		},
	},
	"Skandi Singapore": {
		"Vessel built": "2011",
		"Vessel design": ["AKER DSV 06"],
		"Class definition": [
			"✠ 1A1 DSV(SAT, Surface) Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HELDK Ice(C) NAUT(AW)",
		],
		"Length o.a.": "107.1 m",
		"Length b.p.": null,
		"Breadth mld": "21.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.6 m",
		"Scantling draft": null,
		Accommodation: "100",
		"Service speed": null,
		Charterer: "Chevron",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4 x 3150 kW"],
			"Bow thruster": ["3 x 1500 kW"],
			"Azimuth thruster": ["2 x 3000 kW"],
			"Deck dimension": ["900 m²"],
			"Deck strength": ["5 - 10 t/m²"],
			"Deck capacity": ["2000 t"],
			"Fuel oil": ["1153 m³"],
			"Pot water": ["807 m³"],
			"Helideck dim": ["21 m diam", "12 t"],
			Moonpool: ["(4.2 x 4.2 m)"],
			"ROV hangar": ["292 m²"],
			"Deck crane": ["1 x SWL 5.5 t", "1 x SWL 3 t"],
			"Offshore crane": ["SWL 140 t", "2300 m"],
			"Diving system": ["18 men", "saturated diving", "system installed"],
		},
	},
	"Skandi Skansen": {
		"Vessel built": "2011",
		"Vessel design": ["STX AH04"],
		"Class definition": [
			"✠ 1A1 Supply vessel Tug Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HELDK(S, H) HL(2.8) NAUT(OSV(A)) SF TMON",
		],
		"Length o.a.": "107.2 m",
		"Length b.p.": null,
		"Breadth mld": "24.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.8 m",
		"Scantling draft": null,
		Accommodation: "90",
		"Service speed": null,
		Charterer: "DOF Subsea Norway",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 7680 kW", "4 x 2600 kW"],
			"Bow thruster": ["2 x 1500 kW"],
			"Azimuth thruster": ["1 x 1500 kW"],
			"Stern thruster": ["2 x 1200 kW"],
			"Deck dimension": ["1070 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["3050 t"],
			"Fuel oil": ["2400 m³"],
			"Pot water": ["965 m³"],
			"Drill water": ["1200 m³"],
			"Helideck dim": ["20.88 m", "diam, 12.8 t"],
			Moonpool: ["7.2 x 7.2 m"],
			"ROV hangar": ["66 m²"],
			"Deck crane": ["4 x SWL 3 t", "2 x SWL 5 t"],
			"Offshore crane": ["SWL 250 t", "2600 m"],
			"AH drum": ["1 x 500 t"],
			"Towing drum": ["2 x 500 t"],
			"Chain locker": ["4 x 300 m³"],
			"Shark jaws": ["3 x 800 t"],
			"Towing pins": ["4 x 300 t"],
			"A-Frame SWL": ["260 t", "(if mounted)"],
		},
	},
	"Skandi Urca": {
		"Vessel built": "2014",
		"Vessel design": ["VARD AH11"],
		"Class definition": [
			"✠ 1A1 SF SUPPLY VESSEL TUG E0 DYNPOS-AUTR COMF-V(3) Clean(Design) NAUT-OSV (T) DK(+) TMON",
		],
		"Length o.a.": "93.5 m",
		"Length b.p.": null,
		"Breadth mld": "22.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.9 m",
		"Scantling draft": null,
		Accommodation: "30",
		"Service speed": null,
		Charterer: "Petrobras",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 4500 kW", "2 x 4000 kW"],
			"Bow thruster": ["1 x 880 kW"],
			"Azimuth thruster": ["2 x 880 kW"],
			"Stern thruster": ["1 x 880 kW"],
			"Deck dimensions": ["760 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["1700 t"],
			"Fuel oil": ["1305 m³"],
			"Pot water": ["870 m³"],
			"Drill water": ["3240 m³"],
			"AH drum": ["2 x 460 t"],
			"Towing drum": ["1 x 400 t"],
			"Chain locker": ["1100 m³"],
			"Shark jaws": ["2 x 800 t"],
			"Towing pins": ["2 x 400 t"],
			"Deck crane": ["3 x SWL 5 t"],
			"Torpedo AH frame": ["Yes"],
		},
	},
	"Skandi Vega": {
		"Vessel built": "2010",
		"Vessel design": ["STX AH04"],
		"Class definition": [
			"✠ 1A1 Supply vessel Tug Clean(Design) COMF(V-3) DK(+) DYNPOS(AUTR) E0 HL(2.8) NAUT(OSV(A)) SF TMON",
		],
		"Length o.a.": "109.5 m",
		"Length b.p.": null,
		"Breadth mld": "mld 24.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "7.8 m",
		"Scantling draft": null,
		Accommodation: "88",
		"Service speed": null,
		Charterer: "Equinor",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 7680 kW", "4 x 2600 kW"],
			"Bow thruster": ["2 x 1500 kW"],
			"Azimuth thruster": ["1 x 1.500 kW"],
			"Stern thruster": ["2 x 1200 kW"],
			"Deck dimensions": ["1.070 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["3050 t"],
			"Fuel oil": ["1.219 m³"],
			"Pot water": ["987 m³"],
			Mud: ["602 m³"],
			Brine: ["602 m³"],
			"Drill water": ["3500 m³"],
			"Moon pool": [" 7.2 x 7.2 m"],
			"ROV hangar": [" 68 m²"],
			"AH drum": ["1 x 500 t"],
			"Towing drum": ["2 x 500 t"],
			"Chain lockers": ["4 x 299 m³"],
			"Shark jaws": ["3 x 600 t"],
			"Towing pins": ["6 x 300 t"],
			"AH frame": ["200 t /3.5 x", "4 m lift"],
			"Deck crane": ["1 x knucklelboom", "2 x Cargo roll", "1 x SWL 3 t"],
		},
	},
	"Skandi Vinland": {
		"Vessel built": "2017",
		"Vessel design": ["VARD 3 08", "Multi Purpose Vessel"],
		"Class definition": [
			"✠ 1A1 Fire fighter(I) SPS BIS BWM(T) Clean(Design) COMF(C-3,V-3) DK(+) DYNPOS(AUTR) E0 Ice(1C) NAUT(OSV(A)) OILREC Recyclable SF",
		],
		"Length o.a.": "93.2 m",
		"Length b.p.": null,
		"Breadth mld": "20.0 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": "6.0 m",
		"Scantling draft": null,
		Accommodation: "55",
		"Service speed": null,
		Charterer: "Cenovus",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2 x 1840 kW", "4 x 2420 kW"],
			"Bow thruster": ["2 x 880 kW"],
			"Azimuth thruster": ["2 x 880 kW"],
			"Stern thruster": ["2 x 3000 kW"],
			"Deck dimension": ["715 m²"],
			"Deck strength": ["10 t/m²"],
			"Deck capacity": ["1400 t"],
			"Fuel oil": ["1845 m³"],
			"Pot water": ["710 m³"],
			"Drill water": ["1680 m³"],
			"Brine (combined)": ["457 m³"],
			"Mud (combined)": ["457 m³"],
			"ORO (combined)": ["457 m³"],
			"MEG (combined)": ["457 m³"],
			"Dry bulk": ["243 m³"],
			"ROV hangar": ["1400 m³"],
			"Deck crane": ["2 x SWL", "3 t @ 12 m"],
			"Offshore crane": ["SWL 100 t", "500 m"],
		},
	},
	// NCT OFFSHORE
	Freja: {
		"Vessel built": "2024",
		"Vessel design": ["VARD 9 01 Mid Size", "Dual Function Vessel"],
		"Class definition": [
			"✠ 1A BIS Battery(Power) BWM(T) Clean(Design) COMF(C-3, V-3) DYNPOS(AUTR) E0 LCS NAUT(AW) Recyclable SPS ER(SCR)",
		],
		"Length o.a.": "95.3 m",
		"Length b.p.": "84.9 m",
		"Breadth mld": "21.5 m",
		Bext: "21.5 m",
		Depth: "8.8 m",
		"Design draft": "7.1 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "60",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	// EDDA WIND
	"Monsoon Enabler": {
		"Vessel built": "2025",
		"Vessel design": ["VARD 4 25"],
		"Class definition": [
			"✠ 1A BIS Battery(Power) Clean(Design) COMF(C-2, V-2) Strengthened (DK) DYNPOS(AUTR) E0 NAUT(AW) Recyclable SPS Walk2work Shore power Coat -(PSPC), Fuel ready (LFL [Ti;Mec,S])",
		],
		"Length o.a.": "87.5 m",
		"Length b.p.": "81.9 m",
		"Breadth mld": "19.5 m",
		Bext: null,
		Depth: "7.4 m",
		"Design draft": "5.3 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Notus Enabler": {
		"Vessel built": "2025",
		"Vessel design": ["VARD 4 25"],
		"Class definition": [
			"✠ 1A BIS Battery(Power) Clean(Design) COMF(C-2, V-2) Strengthened (DK) DYNPOS(AUTR) E0 NAUT(AW) Recyclable SPS Walk2work Shore power Coat -(PSPC), Fuel ready (LFL [Ti;Mec,S])",
		],
		"Length o.a.": "87.5 m",
		"Length b.p.": "81.9 m",
		"Breadth mld": "19.5 m",
		Bext: null,
		Depth: "7.4 m",
		"Design draft": "5.3 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	// NORTH STAR
	"Grampian Kestrel": {
		"Vessel built": "2025",
		"Vessel design": ["Vard 4 22"],
		"Class definition": null,
		"Length o.a.": "95 m",
		"Length b.p.": null,
		"Breadth mld": "19.5 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	// OCEAN INFINITY
	"Armada 78 01": {
		"Vessel built": "2023",
		"Vessel design": ["Armada A78"],
		"Class definition": [
			"✠ 1A Clean COMF(C-3, V-3) DK(+) DYNPOS(AUTR) E0 NAUT(OSV) Recyclable SF ER(SCR)",
		],
		"Length o.a.": "78 m",
		"Length b.p.": "72.58 m",
		"Breadth mld": "15 m",
		Bext: "15.44 m",
		Depth: "7 m",
		"Design draft": "5.3 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Owner/Operator": ["Ocean Infinity Group"],
			Flag: ["Singapore"],
			"Remote Control System": ["Vard"],
			"Regulatory Regime": ["Classed IMO (SOLAS, MARPOL)", "DNV Lean Manned TBC"],
			"Dynamic Positioning": ["MT DP2 (DP cap 9, 8, 7, 6)"],
			"Min. Draft": ["5 m"],
			"Displacement (light/full)": ["2500 t/3500 t"],
			"Deck Area": ["690 m²"],
			"Deck Load": ["1050 t"],
			"Moonpool Size": ["Two 9 x 4 m"],
			"Economic Speed": ["8-10 Knots"],
			"Operational Range": ["Global"],
			Endurance: ["21-35 days depending on payload and operation"],
			"Communications Systems": [
				"VHF, point-to-point /",
				"point-to-multipoint radio, satellite",
				"communications, 4G/LTE",
			],
			"Survey Positioning": ["Veripos LD900 DGNSS"],
			"Survey Heading & Attitude": ["Sonardyne Sprint 500 INS"],
			"Single Beam Echosounders": ["N/A"],
			"Multi Beam Echosounders": ["Kongsberg EM124 2° x 2°", "(A7801/02 Only)"],
			"ADCP/DVL": ["Nortek Signature VM 100 ADCP/", "DVL (A7801/02 Only)"],
			Magnetometer: ["Subvision 12-Pin Gradiometer (Attached to Schilling HD)"],
			"ROV/AUV": [
				"Saab Seaeye Leopard ROV",
				"Schilling HD WROV, Saab eWROV",
				"Hugin 3000/6000",
			],
			"VSAT Antennas": [
				"2 x 1 m Ka-Band Antennas",
				"2 x 1.2 m Ku-Band Antennas with",
				"L-Band Back up",
			],
			"Installed Power (kW)": [
				"Available Power with Batteries: 6.5 mW",
				"Total Power with Batteries: 7 mW",
			],
			Batteries: ["2 x 565 kWh Corvus Orca Li-ion"],
		},
	},
	"Armada 78 02": {
		"Vessel built": "2023",
		"Vessel design": ["Armada A78"],
		"Class definition": [
			"✠ 1A Clean COMF(C-3, V-3) DK(+) DYNPOS(AUTR) E0 NAUT(OSV) Recyclable SF ER(SCR)",
		],
		"Length o.a.": "78 m",
		"Length b.p.": "72.58 m",
		"Breadth mld": "15 m",
		Bext: "15.44 m",
		Depth: "7 m",
		"Design draft": "5.3 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Owner/Operator": ["Ocean Infinity Group"],
			Flag: ["Singapore"],
			"Remote Control System": ["Vard"],
			"Regulatory Regime": ["Classed IMO (SOLAS, MARPOL)", "DNV Lean Manned TBC"],
			"Dynamic Positioning": ["MT DP2 (DP cap 9, 8, 7, 6)"],
			"Min. Draft": ["5 m"],
			"Displacement (light/full)": ["2500 t/3500 t"],
			"Deck Area": ["690 m²"],
			"Deck Load": ["1050 t"],
			"Moonpool Size": ["Two 9 x 4 m"],
			"Economic Speed": ["8-10 Knots"],
			"Operational Range": ["Global"],
			Endurance: ["21-35 days depending on payload and operation"],
			"Communications Systems": [
				"VHF, point-to-point /",
				"point-to-multipoint radio, satellite",
				"communications, 4G/LTE",
			],
			"Survey Positioning": ["Veripos LD900 DGNSS"],
			"Survey Heading & Attitude": ["Sonardyne Sprint 500 INS"],
			"Single Beam Echosounders": ["N/A"],
			"Multi Beam Echosounders": ["Kongsberg EM124 2° x 2°", "(A7801/02 Only)"],
			"ADCP/DVL": ["Nortek Signature VM 100 ADCP/", "DVL (A7801/02 Only)"],
			Magnetometer: ["Subvision 12-Pin Gradiometer (Attached to Schilling HD)"],
			"ROV/AUV": [
				"Saab Seaeye Leopard ROV",
				"Schilling HD WROV, Saab eWROV",
				"Hugin 3000/6000",
			],
			"VSAT Antennas": [
				"2 x 1 m Ka-Band Antennas",
				"2 x 1.2 m Ku-Band Antennas with",
				"L-Band Back up",
			],
			"Installed Power (kW)": [
				"Available Power with Batteries: 6.5 mW",
				"Total Power with Batteries: 7 mW",
			],
			Batteries: ["2 x 565 kWh Corvus Orca Li-ion"],
		},
	},
	"Armada 78 03": {
		"Vessel built": "2023",
		"Vessel design": ["Armada A78"],
		"Class definition": [
			"✠ 1A Clean COMF(C-3, V-3) DK(+) DYNPOS(AUTR) E0 NAUT(OSV) Recyclable SF ER(SCR)",
		],
		"Length o.a.": "78 m",
		"Length b.p.": "72.58 m",
		"Breadth mld": "15 m",
		Bext: "15.44 m",
		Depth: "7 m",
		"Design draft": "5.3 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Owner/Operator": ["Ocean Infinity Group"],
			Flag: ["Singapore"],
			"Remote Control System": ["Vard"],
			"Regulatory Regime": ["Classed IMO (SOLAS, MARPOL)", "DNV Lean Manned TBC"],
			"Dynamic Positioning": ["MT DP2 (DP cap 9, 8, 7, 6)"],
			"Min. Draft": ["5 m"],
			"Displacement (light/full)": ["2500 t/3500 t"],
			"Deck Area": ["690 m²"],
			"Deck Load": ["1050 t"],
			"Moonpool Size": ["Two 9 x 4 m"],
			"Economic Speed": ["8-10 Knots"],
			"Operational Range": ["Global"],
			Endurance: ["21-35 days depending on payload and operation"],
			"Communications Systems": [
				"VHF, point-to-point /",
				"point-to-multipoint radio, satellite",
				"communications, 4G/LTE",
			],
			"Survey Positioning": ["Veripos LD900 DGNSS"],
			"Survey Heading & Attitude": ["Sonardyne Sprint 500 INS"],
			"Single Beam Echosounders": ["N/A"],
			"Multi Beam Echosounders": ["Kongsberg EM124 2° x 2°", "(A7801/02 Only)"],
			"ADCP/DVL": ["Nortek Signature VM 100 ADCP/", "DVL (A7801/02 Only)"],
			Magnetometer: ["Subvision 12-Pin Gradiometer (Attached to Schilling HD)"],
			"ROV/AUV": [
				"Saab Seaeye Leopard ROV",
				"Schilling HD WROV, Saab eWROV",
				"Hugin 3000/6000",
			],
			"VSAT Antennas": [
				"2 x 1 m Ka-Band Antennas",
				"2 x 1.2 m Ku-Band Antennas with",
				"L-Band Back up",
			],
			"Installed Power (kW)": [
				"Available Power with Batteries: 6.5 mW",
				"Total Power with Batteries: 7 mW",
			],
			Batteries: ["2 x 565 kWh Corvus Orca Li-ion"],
		},
	},
	// PURUS
	"Purus Chinook": {
		"Vessel built": "2025",
		"Vessel design": null,
		"Class definition": [
			"✠ 1A BIS Battery(Power) BWM(T) Clean(Design) COMF(C-2, V-1) Cyber secure(Essential) DYNPOS(AUTR) E0 Fuel ready(LFL[D; P; Ti]) HELDK LCS NAUT(OC) Recyclable SPS Walk2work ER(SCR)",
		],
		"Length o.a.": "87.55 m",
		"Length b.p.": "80.30 m",
		"Breadth mld": "19.5 m",
		Bext: "19.5 m",
		Depth: "7.4 m",
		"Design draft": "5.6 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "120",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	// REMØY
	"Rem Crusader": {
		"Vessel built": "2010",
		"Vessel design": ["VS 485 CD"],
		"Class definition": [
			"✠ 1A1, Ice C, Dynpos (AUTR), Clean (Design), COMF(C-3, V-3), EO, LFL, SF, Oil Rec, DK(+), HL(P), Compliance to NAUT(OSV(A))",
		],
		"Length o.a.": "85 m",
		"Length b.p.": "77.70 m",
		"Breadth mld": "20.00 m",
		Bext: "20.00 m",
		Depth: "8.60 m",
		"Design draft": "7.16 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "23",
		"Service speed": "14 kn",
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Rem Eir": {
		"Vessel built": "2014",
		"Vessel design": ["VS 4412 DF PSV"],
		"Class definition": [
			"✠ 1A1, OFFSHORE SERVICE VESSEL +, SUPPLY, SF, DYNPOS-AUTR, E0, GAS FUELLED, CLEAN DESIGN, COMF V(3)C(3), LFL*, NAUT OSV(A), DK(10t/m2) and HL(2,8), ESV-DP (HIL), ESV-PMS(HIL)",
		],
		"Length o.a.": "92.50 m",
		"Length b.p.": "84.90 m",
		"Breadth mld": "20.00 m",
		Bext: null,
		Depth: "9.00 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "26",
		"Service speed": "15.5 kn",
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			Design: ["Wartsila Ship Design Norway AS"],
			Authorities: ["NOR"],
			Yard: ["Kleven Verft"],
			"Hull Yard": ["Kleven Verft"],
			"Keel Laying": ["13.08.2013"],
			Delivery: ["20.11.2014"],
			"DNV Id No.": ["32920"],
			"IMO No.": ["9668647"],
			"Signal Letters": ["LEEW"],
			"Cargo Deck": ["1090 m²"],
			"Main Engines": ["Wartsila - 6L34DF", "2 x 2610 kW"],
			"Main Engines ": ["Wartsila - 6L20DF", "2 x 1056 kW"],
			"Emergency generator": ["Volvo Penta D9 MG RC/HCM", "216 ekW"],
			"Main Propulsion": ["Rolls-Royce - AZP 120 FP", "2 x 2450 kW"],
			"Retractable Thruster": ["Rolls-Royce - TCNS 4,5TM FP", "880 kW"],
			"Tunnel Thruster (Fwd)": ["Rolls-Royce - TT2000 DPN CP", "2 x 1200 kW"],
			"Deck Cranes": ["TTS", "2 x 3 T @ 13 m"],
			"Tugger Winches": ["Norwegian Deck Machinery", "2 x 15 T"],
			"Windl./Mooring Winches": ["Norwegian Deck Machinery", "2 x 17 T"],
			"Mooring Winches (aft)": ["Norwegian Deck Machinery", "2 x 12 T"],
			"LNG system/tank": ["Wartsila LNGPac", "230 m³"],
			Bolier: ["Ulmatec Pyro", "600 kW"],
			BWTS: ["Optimarin", "170 m³/h"],
			"Lightweight (approx)": ["4041 t"],
			"Deck Load": ["approx. 3200 t"],
			"Fuel Oil": ["1000 m³"],
			"Drill Water/Water Ballast": ["1800 m³"],
			"Fresh Water Cargo": ["1000 m³"],
			MUD: ["980 m³"],
			"Base Oil": ["150 m³"],
			Brine: ["830 m³"],
			Slop: ["50 m³"],
			"Dry Bulk (4 tanks)": ["330 m³"],
			Methanol: ["230 m³"],
			"Special Product": ["400 m³"],
			"DP System": ["Rolls-Royce Icon™"],
			"DE System": ["Wartsila"],
			IAS: ["Wartsila"],
			"Cargo Equipment": ["Allweiler"],
			HVAC: ["Novenco"],
			Separators: ["Alfa Laval"],
			"Navigation & Comm.": ["Hareid Marine Technology"],
			"Internal FiFi System": ["Autronica"],
		},
	},
	"Rem Hrist": {
		"Vessel built": "2011",
		"Vessel design": ["PX105"],
		"Class definition": [
			"✠ 1A1, SF, DYNPOS AUTR, Clean Design, OPP-F, COMF-V(3), COMFC(2), LFL*, ICE-C, NAUT-OSV(A), OILREC, Standby Vessel, Supply Vessel, DK(+), HL(2.8) , E0",
		],
		"Length o.a.": "88.80 m",
		"Length b.p.": "82.00 m",
		"Breadth mld": "19.00 m",
		Bext: "19.05 m",
		Depth: "8.00 m",
		"Design draft": "6.6 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "24",
		"Service speed": "15.4 kn",
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	"Rem Mist": {
		"Vessel built": "2011",
		"Vessel design": ["PX105"],
		"Class definition": [
			"✠ 1A1, SF, DYNPOS AUTR, Clean Design, OPP-F, COMF-V(3), COMFC(2), LFL*, ICE-C, NAUT-OSV(A), OILREC, Standby Vessel, Supply Vessel, DK(+), HL(2.8) , E0",
		],
		"Length o.a.": "88.80 m",
		"Length b.p.": "82.00 m",
		"Breadth mld": "19.00 m",
		Bext: "19.05 m",
		Depth: "8.00 m",
		"Design draft": "6.6 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "24",
		"Service speed": "15.4 kn",
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: null,
	},
	// SOLSTAD
	"Normand Drott": {
		"Vessel built": "2010",
		"Vessel design": ["AH 12"],
		"Class definition": [
			"✠ 1A1, SF, E0, DK(+), HL(2,8),",
			"TUG, SUPPLY VESSELl, COMF-V(3),",
			"CLEAN DESIGN, DYNPOS-AUTR,",
			"NAUT OSV(A), TMON",
		],
		"Length o.a.": "95 m",
		"Length b.p.": null,
		"Breadth mld": "24 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "70 Persons",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Bollard pull",
		CapacityUnit: "t",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			Yard: ["Aker Yard Brattvåg"],
			Flag: ["NOR"],
			"Classification Society": ["DNV GL"],
			"Dynamic Positioning": ["DP 2 from Kongsberg"],
			"Deck Dimensions": ["760,2 m² (36,2 m x 21 m)"],
			"Total BHP": ["32792 BHP"],
			"ROV system": ["WROV"],
		},
	},
	"Normand Frontier": {
		"Vessel built": "2014",
		"Vessel design": ["Vard 3 03"],
		"Class definition": [
			"✠ 1A1, SF, E0, DK(+), COMF-V(3)C(3),",
			"SPS, CLEAN DESIGN, DYNPOS-AUTR,",
			"NAUT-AW, ICE-C, TMON, BIS,",
			"CRANE, HELDK-SH",
		],
		"Length o.a.": "121 m",
		"Length b.p.": null,
		"Breadth mld": "23 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "100",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			Yard: ["VARD Aukra", "Yard No. 825"],
			Flag: ["NIS"],
			Owner: ["Solstad Maritime"],
			"Classification Society": ["DNV GL"],
			"Cargo Deck Area": ["1400 m²"],
			ROV: ["Yes"],
			DP: ["DP 2", "Kongsberg"],
			"Main Crane": ["1 x SWL 250 mt @ TBCm - Single fall - AHC - CT"],
		},
	},
	"Normand Navigator": {
		"Vessel built": "2015",
		"Vessel design": ["Vard 3 07"],
		"Class definition": [
			"✠ 1A1, SF, E0, DK(+), COMF-V(2)C(3), SPS, CLEAN DESIGN, DYNPOS-AUTRO, NAUT-AW, ICE-C, TMON, VIBR, BIS, CRANE, HELDK-SH (CAA-N), ESV-DP(HIL)",
		],
		"Length o.a.": "142.6 m",
		"Length b.p.": null,
		"Breadth mld": "25 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "130",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			Yard: ["VARD Langsten", "Yard No. 822"],
			Flag: ["NIS"],
			"Dynamic Positioning": ["DP 3 from Rolls Royce"],
			"Deck Dimensions": ["1800 m²"],
			"ROV system": ["2 WROVs"],
			"Main Crane": ["1 x SWL 250mt@ 17m", "Single fall - AHC"],
			"Crane 2": ["1 x SWL 50mt@ 11m", "Single fall - AHC"],
		},
	},
	"Normand Ocean": {
		"Vessel built": "2014",
		"Vessel design": ["MT 6022"],
		"Class definition": [
			"✠ 1A1, SF, E0, DK(+), COMF-V(3)C(3),",
			"SPS, CLEAN DESIGN, DYNPOS-AUTRO,",
			"NAUT OSV(A), NAUT-AW, ICE-C,",
			"DEICE, HELDK-SH, Battery (Power),",
		],
		"Length o.a.": "107.6 m",
		"Length b.p.": null,
		"Breadth mld": "22 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "90 Persons",
		"Service speed": null,
		Charterer: "DeepOcean AS",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			Flag: ["NIS"],
			"Cargo Deck Area": ["1170 m²"],
			ROV: ["Yes"],
			Yard: ["Kleven Yard (no. 352)"],
			Classification: ["DNV GL"],
			DP: ["DP 2 (Kongsberg)"],
			Helideck: ["Diameter 26 m", "16mt Sikorsky 92"],
			"Draft (max)": ["7.15 m + 0m", "Skeg/Nozzle"],
			"Deck Cargo Capacity": ["1800 mt (CoG 1.0 m", "above main deck)"],
			"Deck Strength": ["10 mt/m²"],
			Moonpool: ["51.84 m² (7.2 m x 7.2 m)"],
			"ROV system": ["1 obs ROV, 2 WROV"],
			"Main Crane": [
				"1 x SWL 150 mt@ 13 m - Single fall - AHC - CT:N/A- Sealift:N/A",
				"Personnel lift: N/A - placed on Port Side",
				"Wire lenght: TBCm - Wire diameter: TBCmm",
			],
		},
	},
	"Normand Sentinel": {
		"Vessel built": "2015",
		"Vessel design": ["Vard 3 07"],
		"Class definition": [
			"✠ 1A1, SF, E0, DK(+), COMF-V(2)C(3), SPS, CLEAN DESIGN, DYNPOS-AUTRO, NAUT-AW, ICE-C, TMON, VIBR, BIS, CRANE, HELDK-SH (CAA-N), ESV-DP(HIL)",
		],
		"Length o.a.": "142.6 m",
		"Length b.p.": null,
		"Breadth mld": "25 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "130",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			Yard: ["VARD Langsten", "Yard No. 822"],
			Flag: ["NIS"],
			"Dynamic Positioning": ["DP 3 from Rolls Royce"],
			"Deck Dimensions": ["1800 m²"],
			"ROV system": ["2 WROVs"],
			"Main Crane": ["1 x SWL 250mt@ 17m", "Single fall - AHC"],
			"Crane 2": ["1 x SWL 50mt@ 11m", "Single fall - AHC"],
		},
	},
	"Normand Vision": {
		"Vessel built": "2014",
		"Vessel design": ["Vard 3 06"],
		"Class definition": [
			"✠ 1A1, SF, E0, DK(+), COMF-V(3)C(3),",
			"SPS, CLEAN DESIGN, DYNPOS-AUTRO,",
			"NAUT-AW, ICE-C, TMON,",
			"VIBR, BIS, CRANE, HELDK-SH",
		],
		"Length o.a.": "15 7m",
		"Length b.p.": null,
		"Breadth mld": "27 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "140 Persons (70 x 1 Person, 35 x 2 Persons)",
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			Flag: ["NIS"],
			"Cargo Deck Area": ["2100 m²"],
			ROV: ["Yes"],
			Yard: ["VARD Søviknes / Yard No. 811"],
			"Classification Society": ["DNV GL"],
			"Dynamic Positioning": ["DP 3 from Kongsberg"],
			Helideck: ["Diameter21m, 15 mt Sikorsky 92"],
			Moonpool: ["41,04 m² (7,2 m x 5,7 m)"],
			"ROV system": ["2 WROV"],
			"Main Crane": ["SWL 400 mt - Single fall - AHC"],
			"Crane 2": ["SWL 50/100 mt @ 12 m - Single & double fall - AHC"],
		},
	},
	// SØLVTRANS
	"Ronja Aurora": {
		"Vessel built": "2023",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "76.96 m",
		"Length b.p.": null,
		"Breadth mld": "17.80 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "13 knots",
		Charterer: "Salmar",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Propulsion system/Gear": ["Brunvoll Volda"],
			Generators: ["2xCAT 3512 C", "Pon Power"],
			"Emergency generator": ["Scania DI 13 75 M", "Nogva Motorfabrikk"],
			"Side thrusters": ["1x600 kW, 2x500 kW", "Brunvoll"],
			"Steering gear": ["Kongsberg Maritime"],
			"Deck cranes": ["4xPalfinger", "Bergen Hydraulic"],
			"Anchor winch": ["Scan Hvide Sande"],
			"Anchor equipment": ["Fossen Shipping"],
			"MOB boat/cranes": ["Mare Safety"],
			"Interior works": ["R&M Ship Interior"],
			"Ventilation system": ["Copra Drift"],
			"Provisions cooling system": ["Multi Kulde Vest"],
			"Interior doors": ["Baggerød"],
			"Toilet facilities": ["Jets Vacuum"],
			"Galley equipment": ["Beha-Hedo Industrier"],
			"Helm seats": ["NorSap"],
			Furniture: ["Shipnor"],
			"Loading/Unloading system/sorting counter": ["MMC First Process"],
			"Fish counters": ["AquaScan", "MSD Animal Health"],
			"Water treatment equipment": ["Sterner"],
			"RSW system": ["PTG Frionordica"],
			"Lice filter": ["MossHydro"],
			Pumps: ["PG Flow Solutions", "Allweiler"],
			"Fire/Rescue equipment": ["Certex Norge"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["Furuno", "O. Øverland"],
			"Exterior doors": ["Libra-Plast"],
			Windows: ["Husna"],
			"Valves/Pipes equipment": ["Robinet", "Brødrene Dahl"],
			"CO2 fire extinguishing": ["John. Con. Nor. avd. Tyco Mar."],
			Paint: ["Carboline/International", "Wisting"],
			"Tank valves": ["John Gjerde"],
			Actuators: ["Eltorque"],
			"Pipe/cable penetrations": ["Roxtec"],
			Typhon: ["R. Stahl Tranberg"],
			Filtration: ["Øwre-Johnsen"],
		},
	},
	"Ronja Azul": {
		"Vessel built": "2022",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "76.96 m",
		"Length b.p.": null,
		"Breadth mld": "17.80 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "13 knots",
		Charterer: "Mowi",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Yanmar 6EY26W", "Maritime Motor"],
			"Gear/Propulsion system": ["Brunvoll Volda"],
			"Steering gear": ["Kongsberg"],
			"Auxiliary engines": ["CAT 3512 C", "Pon Power"],
			"Shore power unit": ["Scania DI 13 75 M", "Nogva Motorfabrikk"],
			"Side thrusters": ["2x500 kW, 1x600 kW", "Brunvoll"],
			Pumps: ["PG Flow Solutions", "Allweiler"],
			"CO2 fire extinguishing": ["Tyco"],
			"Deck cranes": ["4xPalfinger", "Bergen Hydraulic"],
			"Anchor winches": ["Scan"],
			"Anchor equipment": ["Fossen Shipping"],
			"MOB boat/cranes": ["Mare Safety"],
			"Loading/Unloading system": ["MMC First Process"],
			"Interior work": ["Norwegian Marine Interior"],
			"Ventilation system": ["Copra"],
			"Provision cooling system": ["Multi Kulde Vest"],
			"Internal doors": ["Baggerød", "Norwegian Marine Interior"],
			"Toilet system": ["Jets Vacuum"],
			Galley: ["Beha-Hedo Industrier"],
			Electronics: ["Vik Elektro", "O. Øverland"],
			"External doors": ["Libra-Plast"],
			Windows: ["Husna"],
			"Fire/Rescue equipment": ["Certex Norge"],
			"Fish counters": ["AquaScan/Vaki"],
			"Ozone/oxygen system/UV system": ["Sterner"],
			"RSW system": ["PTG FrioNordica"],
			"Lice filter": ["MossHydro"],
			"Painting systems": ["Carboline Norge"],
			"Valve/pipe equipment": ["Robinet", "Brødrene Dahl"],
			"Cable/pipe penetrations": ["Roxtec"],
			"Navigation/Communication systems": ["Furuno"],
			"SCR system": ["H+H Engineering & Service"],
			Furniture: ["ShipNor"],
			Typhoon: ["R. Stahl Tranberg"],
			"Windshield wipers": ["Exalto Decca Wiper Technologies"],
		},
	},
	"Ronja Borøy": {
		"Vessel built": "2023",
		"Vessel design": ["Salt Ship Design"],
		"Class definition": null,
		"Length o.a.": "92.66 m",
		"Length b.p.": "84.99 m",
		"Breadth mld": "22.4 m",
		Bext: null,
		Depth: "9.60 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "16",
		"Service speed": "12 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["4xScania DI 13", "Scania CV"],
			"Propulsion thrusters": ["2xUSE 255 FP", "Kongsberg Maritime"],
			"Tunnel thrusters": ["2xTT1650 DP FP", "Kongsberg Maritime"],
			"Emergency generator": ["Scania DI 13", "Scania CV"],
			"Fish handling system": ["MMC First Process"],
			Cranes: ["4 stk.", "Red Rock"],
			"MOB boat/cranes": ["Red Rock"],
			Delousing: ["FLS Caligus R670", "Flatsetsund Engineering"],
			"Rudder house door": ["Libra-Plast"],
			"Classification society": ["DNV"],
			"Pipe/cable penetrations": ["CSD Sealing Systems", "Roxtec"],
		},
	},
	"Ronja Challenger": {
		"Vessel built": "2016",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "69.86 m",
		"Length b.p.": "66.98 m",
		"Breadth mld": "12 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": "12.6 knots",
		Charterer: "Mowi UK",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["8L20, 1600 kW", "Wärtsila"],
			"Auxiliary engines": ["Pon Power"],
			"Emergency/harbor generator": ["Nogva Motorfabrikk"],
			"Gear/propulsion equipment": ["Scana Volda"],
			Pumps: ["PG Flow Solutions", "Allweiler"],
			"Side thrusters": ["1x450 kW, 1x300 kW", "Brunvoll"],
			"Steering gear": ["Rolls Royce Marine"],
			"Maneuvering system": ["Scana Volda"],
			"Valve/pipe equipment": ["Robinet", "Brødrene Dahl"],
			"Bunkering solutions": ["Øwre-Johnsen"],
			"Deck cranes": ["Bergen Hydraulic"],
			"Anchor winch": ["Rapp Hydema"],
			"MOB boat/cranes": ["Mare Safety"],
			"Anchor equipment": ["Fossen Shipping"],
			"Exterior doors": ["Libra-Plast"],
			"Fire/Rescue equipment": ["Erling Haug"],
			"Vacuum pump system": ["Havyard MMC"],
			"Fish counters": ["AquaScan"],
			"Smolt counters": ["VAKI"],
			"Ozone system": ["Redox"],
			"UV system": ["Sterner"],
			"Louse filter": ["Salsnes Filter"],
			Interior: ["R&M Ship Interior"],
			"Helm seats": ["Alu-Design"],
			"Wardrobe/tool cabinets": ["SSG"],
			"Ventilation system": ["Wangsmo"],
			"Interior doors": ["Norac Baggerød"],
			Window: ["Bohamet Spolka Akcyjna"],
			"Provisions cooling system": ["Trondheim Kulde"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["O. Øverland"],
			Paint: ["International/Westing"],
			"CO2 fire extinguishing": ["Wilhelmsen Technical Solutions"],
		},
	},
	"Ronja Christopher": {
		"Vessel built": "2020",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "69,96 m",
		"Length b.p.": null,
		"Breadth mld": "17.80 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": "13 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Yanmar 6EY26W, 1900 kW", "Maritim Motor"],
			"Thrusters/Gear/Propulsion system": ["Brunvoll Volda"],
			"Auxiliary engines": ["Cat", "Pon Power"],
			"Shore/Emergency generator": ["DI 13 75 M", "Nogva Motorfabrikk"],
			"Steering gear": ["Kongsberg Maritime"],
			"Filtration lub oil/fuel": ["Øwre-Johnsen"],
			"Deck cranes": ["Bergen Hydraulic"],
			"Anchor winch": ["AS Scan"],
			"Sorting counter/Loading/Unload system": ["MMC First Process"],
			"Fish counters": ["AquaScan/Vaki"],
			"Smolt counter": ["Vaki"],
			"Ozone system/UV-system/Lice filter": ["Sterner"],
			"RSW system": ["PTG FrioNordica"],
			"Anchor equipment": ["Fossen Shipping"],
			"MOB boat/cranes": ["Maritime Partner"],
			Lights: ["Luminell"],
			Typhon: ["R. Stahl Tranberg"],
			"Navigation lights/search lights": ["Glamox"],
			Furnishing: ["R&M Ship Interior/Shipnor"],
			"Ventilation system": ["Wangsmo"],
			"Provision fridge system": ["Trondheim Kulde"],
			"Exterior doors": ["Libra-Plast"],
			"Interior doors": ["Baggerød/R&M Ship Interior"],
			"Interior lights": ["Glamox"],
			Windows: ["Bohamet"],
			"Toilet facilities": ["Jets"],
			"Windshield wipers": ["Decca Technology"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["HG Teknikk"],
			Pumps: ["PG Flow Solutions"],
			"Div. pumps": ["Allweiler"],
			"Fire/Rescue equipment": ["Certex Norge"],
			Paint: ["Carboline/Multi Marine"],
			"Valves/Pipes equipment": ["Robinet"],
			"Valve equipment": ["Brødrene Dahl"],
			"Fire fighting system": ["Tyco Fire & Integrated Solutions"],
			Filter: ["Moss Hydro"],
			"Pipe/cable penetrations": ["Roxtec"],
			"Anti fouling": ["MPE Cathodic"],
			"Safety equipment": ["Viking Norsafe Life-Saving Euipment"],
		},
	},
	"Ronja Evolution": {
		"Vessel built": "2024",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "76,96 m",
		"Length b.p.": null,
		"Breadth mld": "5,90 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "13 knots",
		Charterer: "Mowi",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Yanmar 6EY26W", "Maritim Motor"],
			Gear: ["Brunvoll Volda"],
			"Propulsion system": ["Brunvoll Volda"],
			"Auxiliary engines": ["2xCAT 3512 C", "Pon Power"],
			"Emergency generator": ["Scania DI 13 75M", "Nogva Motorfabrikk"],
			"Steering gear": ["Kongsberg Maritime"],
			"Valves/Pipes equipment": ["Robinet", "Brødrene Dahl"],
			Hydraulics: ["Bergen Hydraulic"],
			"CO2 fire extinguishing": ["Tyco Fire & Integrated"],
			Pumps: ["PG Flow Solutions", "Allweiler"],
			"Side thrusters": ["Brunvoll"],
			"Deck cranes": ["Storm Cranes"],
			"Anchor winch": ["Scan"],
			"Anchor equipment": ["Fossen Shipping"],
			"MOB boat": ["Mare Safety"],
			"MOB boat cranes": ["Storm Cranes"],
			"Navigation lights": ["R. Stahl Tranberg"],
			"Search lights": ["R. Stahl Tranberg"],
			Typhon: ["R. Stahl Tranberg"],
			"Fish counters": ["Aquan Scan", "MSD Animal Health"],
			"Loading system": ["MMC First Process"],
			"Unloading system": ["MMC First Process"],
			"Ozone system": ["Sterner"],
			"Oxygen system": ["Sterner"],
			"RSW system": ["PTG Frionordica"],
			"UV-anlegg": ["Sterner"],
			"Lice filter": ["MossHydro"],
			Furnishing: ["R&M Ship Interior"],
			"Interior doors": ["R&M Ship Interior", "Baggerød"],
			"Ventilation system": ["Copra Drift"],
			"Provision fridge system": ["Multi Kulde Vest"],
			"Toilet facilities": ["Jets Vacuum"],
			"Helm seats": ["NorSap"],
			"Tank air valves": ["John Gjerde"],
			Actuators: ["Eltorque"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["Furuno", "O. Øverland"],
			"Fire equipment": ["Certex Norge"],
			"Rescue equipment": ["Certex Norge"],
			"Exterior doors": ["Libra-Plast"],
			Windows: ["Karaca Gemi"],
			Paint: ["Carboline Norge"],
			"Pipe/cable penetrations": ["Roxtec"],
			Furniture: ["Shipnor"],
		},
	},
	"Ronja Explorer": {
		"Vessel built": "2019",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "69.96 m",
		"Length b.p.": null,
		"Breadth mld": "17.80 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": "13 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Yanmar 6EY26W, 1900 kW", "Maritim Motor"],
			Gear: ["Brunvoll Volda"],
			"Propulsion system": ["Brunvoll Volda"],
			"Auxiliary engines": ["Cat,Pon Power"],
			Thrusters: ["Brunvoll"],
			"Steering gear": ["Kongsberg Maritime"],
			"Filtration lub oil/fuel": ["Øwre-Johnsen"],
			"Deck cranes": ["Bergen Hydraulic"],
			"Anchor winch": ["Adria Winch"],
			"Loading/Unloading system": ["MMC First Process"],
			"Fish counters": ["AquaScan/Vaki"],
			"Smolt counter": ["Vaki"],
			Sorteringsteller: ["MMC First Process"],
			"Ozone system": ["Sterner"],
			"RSW system": ["FrioNordica"],
			"UV-system/Lice filter": ["Sterner"],
			"Anchor equipment": ["Fossen Shipping"],
			"MOB boat/cranes": ["Maritime Partner"],
			Furnishing: ["R&M Ship Interior"],
			"Ventilation system": ["Wangsmo"],
			"Provision fridge system": ["Trondheim Kulde"],
			"Exterior doors": ["Libra-Plast"],
			"Interior doors": ["Baggerød/R&M Ship Interior"],
			Windows: ["Bohamet"],
			"Toilet facilities": ["Jets"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["Furuno Norge", "HG Marine Electronics"],
			Pumps: ["PG Flow Solutions/Allweiler"],
			"Fire/Rescue equipment": ["Certex Norge"],
			Paint: ["Multi Maritime/Carboline"],
			"Valves/Pipes equipment": ["Robinet/Brødrene Dahl"],
			Financing: ["Nordea"],
			"Fire fighting system": ["Tyco Fire & Integrated Solutions"],
		},
	},
	"Ronja Harvester": {
		"Vessel built": "2007",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "68.00 m",
		"Length b.p.": "62.72 m",
		"Breadth mld": "14.00 m",
		Bext: null,
		Depth: "6.30 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": "14 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"RSW system": ["2 x 600.000 kcal/t", "Aquaterm"],
			"Main engines": ["Caterpillar 3516TAHD 2610 HP, 1600 o/min.", "Pon Power"],
			"Generator set": ["Caterpillar 3512TA B, 1375 kW", "Pon Power"],
			"Shore generator": ["Caterpillar C9TA, 170 kW", "Pon Power"],
			"Shaft generator": ["1500 kW", "Newage Norge"],
			"Gear/Propulsion equipment": ["Finnøy Gear & Propeller"],
			"Steering gear": ["Type Tenfjord", "Rolls-Royce avd. Tennfjord"],
			"Maneuvering system": ["Finnøy Gear & Propeller/ Scana Mar-El"],
			Pumps: ["Ing. Per Gjerdrum"],
			"Hoses, pipes, couplings, flanges": ["GS-Hydro"],
			Electronics: ["O. Øverland"],
			"Ventilation system": ["Wangsmo"],
			"Ozone system": ["Redox"],
			"CO2 system": ["Heien-Larssen"],
			"Fire/Rescue equipment": ["Erling Haug"],
			"Valve equipment": ["Ahlsell/Ålesund Armatur"],
			"Anchor winch": ["Rapp Hydema"],
			"Deck cranes": ["Bergen Hydraulic"],
			"Vacuum pump system": ["Stranda Prolog"],
			"Fish counters": ["AquaScan"],
			"Anchor equipment": ["Fossen Shipping"],
			"Mob boat": ["Erling Haug"],
			Lifeboats: ["Viking", "Mare Safety"],
			"Windshield wipers": ["Servi Motion Control"],
			Windows: ["Zaklad Produkcyjny Bohamet"],
			"Electrical installations": ["Vik Elektro"],
			Furnishing: ["R&M Ship Interior"],
			Furniture: ["Troldmyr Møbelfabrikk/Vad"],
			"Exterior doors": ["Libra-Plast"],
			"Interior doors": ["Norac Baggerød"],
			Paint: ["International, Roja"],
		},
	},
	"Ronja Havsøy": {
		"Vessel built": "2020",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "84.46 m",
		"Length b.p.": null,
		"Breadth mld": "16.00 m",
		Bext: null,
		Depth: "8.30 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "11 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Fuel oil": ["326 m³"],
			"Fresh water": ["770 m³"],
			"Ballast water": ["975 m³"],
			"Main engines": ["Yanmar"],
			"Electric engines": ["Elkon"],
			"Propulsion system": ["Schottel"],
			"Shore/Emergency generator": ["Scania", "Margen"],
			Thrusters: ["Schottel"],
			"Starters side thrusters/Batteries": ["Elkon"],
			Cranes: ["Red Rock"],
			"Deck machinery": ["Adria Winch"],
			"RSW system": ["PTG FrioNordica"],
			"Freezing facility": ["PTG Kuldeteknisk"],
			"Fish handling system": ["Cflow/Redox"],
			"Fish counters": ["Aquascan"],
			"MOB boat/cranes": ["Red Rock"],
			"Smolt counter": ["Vaki"],
			Lifeboats: ["RFD"],
			"Navigation lights": ["R. Stahl Tranberg"],
			"Search lights": ["Glamox/Norselight"],
			"Flood light/bow light": ["Luminell"],
			Furnishing: ["Domgusel"],
			"Panels/doors": ["HBM"],
			Insulation: ["Paroc"],
			"Helm seats": ["Alu Design"],
			"Ventilation system": ["Heinen Hopman"],
			Osmose: ["Norwater"],
			"Vacuum toilet": ["Jets"],
			"Exterior doors": ["Libra Plast"],
			"Ballast water treatment": ["Optimarin"],
			CCTV: ["Elektronix"],
			Intercom: ["Zenitel"],
			"Navigation system": ["Furuno Norge", "Ozsay Deniz"],
			"Bridge consoles": ["Elkon"],
			Scrubber: ["Gesab"],
			"HP washers": ["HL. Skjong"],
			"Air receiver": ["Maskinspecialisten"],
			Paint: ["Jotun"],
			"Drum filter": ["CM Aqua Technologyies"],
			"Hospital equipment": ["Shipmed"],
		},
	},
	"Ronja Herøy": {
		"Vessel built": "2023",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "92.66 m",
		"Length b.p.": null,
		"Breadth mld": "22.40 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "16",
		"Service speed": "12 knots",
		Charterer: "Mowi",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main generators": ["4xDI 13", "Scania CV"],
			"Propulsion thrusters": ["2xUSE 255 FP", "Kongsberg Maritime"],
			"Side thrusters": ["2xTT1650 DP FP", "Kongsberg Maritime"],
			"Emergency generator": ["DI 13", "Scania CV"],
			"Fish handling system": ["MMC First Process"],
			"MOB boat/cranes": ["Red Rock"],
			"Cable/pipe penetrations": ["Roxtec", "CSD Sealing Systems"],
			"Ship design": ["Salt Ship Design"],
			"Classification society": ["DNV"],
			"Navigation lights": ["R. Stahl Tranberg"],
			"Rudder house door": ["Libra-Plast"],
			Delousing: ["FLS Caligus R670", "Flatsetsund Engineering"],
		},
	},
	"Ronja Kvaløy": {
		"Vessel built": "2019",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "76.86 m",
		"Length b.p.": "69.75 m",
		"Breadth mld": "15.00 m",
		Bext: "15.07 m",
		Depth: "8.01 m",
		"Design draft": "6.68 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main generators": ["4x QSK38-M", "Cummins Inc."],
			"Propulsion thrusters": ["2x SRP 260 FP", "SCHOTTEL GmbH"],
			"Tunnel thrusters": ["STT 001 FP", "SCHOTTEL GmbH"],
			"Classification society": ["DNV"],
		},
	},
	"Ronja Mistral": {
		"Vessel built": "2023",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "76.96 m",
		"Length b.p.": null,
		"Breadth mld": "17.80 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "13 knots",
		Charterer: "Spot og Bremnes",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["6EY26W", "Yanmar Europe", "Maritim Motor"],
			"Propulsion system/gear": ["Brunvoll Volda"],
			Generators: ["2xCAT 3512 C", "Pon Power"],
			"Emergency generator": ["Scania DI 13 75 M", "Nogva Motorfabrikk"],
			"Side thrusters": ["1x600 kW, 2x500 kW", "Brunvoll"],
			"Steering gear": ["Kongsberg Maritime"],
			"Deck cranes": ["4xPalfinger", "Bergen Hydraulic"],
			"Anchor winch": ["Scan"],
			"Anchor equipment": ["Fossen Shipping"],
			"MOB boat/cranes": ["Mare Safety"],
			"Interior works": ["R&M Ship Interior"],
			"Ventilation system": ["Copra Drift"],
			"Provisions cooling system": ["Multi Kulde Vest"],
			"Interior doors": ["Baggerød"],
			"Toilet facilities": ["Jets Vacuum"],
			"Galley equipment": ["Beha-Hedo Industrier"],
			"Helm seats": ["NorSap"],
			"Loading/Unloading system/Sorting counter": ["MMC First Process"],
			"Fish counters": ["AquaScan", "MSD Animal Health"],
			"Ozone/oxygen/UV system": ["Sterner"],
			"RSW system": ["PTG Frionordica"],
			"Lice filter": ["MossHydro"],
			Pumps: ["PG Flow Solutions", "Allweiler"],
			"Fire/Rescue equipment": ["Certex Norge"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["O. Øverland"],
			"Exterior doors": ["Libra-Plast"],
			Windows: ["Husna"],
			"Valves/Pipes equipment": ["Robinet", "Brødrene Dahl"],
			"CO2 fire extinguishing": ["Tyco Fire & Integrated Solutions"],
			Paint: ["Carboline/International", "Wisting"],
			Actuators: ["Eltorque"],
			"Tank valves": ["John Gjerde"],
			"Pipe/cable penetrations": ["Roxtec"],
			Furniture: ["Shipnor"],
		},
	},
	"Ronja Nærøysund": {
		"Vessel built": "2022",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "87.10 m",
		"Length b.p.": "84.80 m",
		"Breadth mld": "18.00 m",
		Bext: null,
		Depth: "8.00 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "12 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["3xCat 3512C 1550 ekW", "Pon Power"],
			Gear: ["650 GHC-V-SC 500", "Kongsberg Maritime"],
			"Steering machine": ["SR662 FCP", "Kongsberg Maritime"],
			"Emergency generator": ["Scania DI 13 75 M", "Nogva Motorfabrikk"],
			"Tunnel thrusters": ["2xTT1650FP-630 kW", "Kongsberg Maritime"],
		},
	},
	"Ronja Princess": {
		"Vessel built": "2022",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "76.96 m",
		"Length b.p.": null,
		"Breadth mld": "17.80 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "13 knots",
		Charterer: "Salmar",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Yanmar 6EY26W 1920kW", "Maritime Motor"],
			"Auxiliary engines": ["2xCAT 3512 C 1550ekW", "Pon Power"],
			"Gear/Propulsion system": ["Brunvoll Volda"],
			"Shore power unit": ["Scania DI 1375M 349ekW", "Nogva Motorfabrikk"],
			"Side thrusters": ["1x600kW, 2x250kW", "Brunvoll"],
			Pumps: ["PG Flow Solutions/Allweiler"],
			"Steering gear": ["Kongsberg Maritime"],
			"MOB boat/cranes": ["Mare Safety"],
			"Deck cranes": ["Palfinger", "Bergen Hydraulic"],
			"Anchor winch": ["Scan"],
			Anchor: ["Fossen Shipping"],
			"Loading/Unloading system": ["MMC First Process"],
			"Fish counters": ["AquaScan", "Vaki"],
			"Sorting counters": ["MMC First Process"],
			"Interior work": ["Norwegian Marine Interior", "ShipNor"],
			"Ventilation system": ["Copra"],
			"Internal doors": ["Baggerød"],
			"Toilet system": ["Jets Vacuum"],
			Galley: ["Beha-Hedo Industrier"],
			"Windshield wipers": ["Exalto Decca Wiper Technologies"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["Furuno", "O. Øverland"],
			"Fire/Rescue equipment": ["Certex Norge"],
			"Provision cooling system": ["GK Inneklima"],
			"External doors": ["Libra-Plast"],
			"Ozone/UV system": ["Sterner"],
			"RSW system": ["PTG FrioNordica"],
			"Lice filter": ["MossHydro"],
			Painting: ["Carboline"],
			"Valve/pipe equipment": ["Robinet", "Brødrene Dahl"],
			"CO2 fire extinguishing": ["Tyco"],
			"SCR system": ["H+H Engineering & Service"],
			"Pipe/cable penetrations": ["Roxtec"],
			"Helm seats": ["NorSap"],
		},
	},
	"Ronja Queen": {
		"Vessel built": "2022",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "76.96 m",
		"Length b.p.": null,
		"Breadth mld": "17.80 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "13 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Gear/Propulsion system": ["Brunvoll Volda"],
			"Auxiliary engines": ["2xCAT 3512 C", "Pon Power"],
			"Emergency generator": ["Scania DI 13 75 M", "Nogva Motorfabrikk"],
			"Side thrusters": ["3 stk.", "Brunvoll"],
			"Steering gear": ["Kongsberg Maritime"],
			Pumps: ["PG Flow Solutions/Allweiler"],
			Cranes: ["4xPalfinger", "Bergen Hydraulic"],
			"MOB boat/kran": ["Mare Safety"],
			"Anchor winch": ["Scan"],
			"Anchor equipment": ["Fossen Shipping"],
			"Fish counters": ["Aqua Scan/MSD"],
			Furnishing: ["R&M Ship Interior"],
			"Ventilation system": ["Copra"],
			"Provision fridge system": ["Multi Kulde Vest"],
			"Interior doors": ["Baggerød"],
			"Toilet facilities": ["Jets Vacuum"],
			"Galley equipment": ["Beha-Hedo Industrier"],
			"Helm seats": ["NorSap"],
			"Loading/Unloading system": ["MMC First Process"],
			"Oxygen/UV system": ["Sterner"],
			"RSW system": ["PTG Frionordica"],
			"Lice filter": ["Mosshydro"],
			Actuators: ["Eltorque"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["Furuno", "O. Øverland"],
			"Fire/Rescue equipment": ["Certex Norge"],
			"Exterior doors": ["Libra-Plast"],
			Windows: ["Husna"],
			Paint: ["Carboline Norge"],
			"Valves/Pipes equipment": ["Robinet/Brødrene Dahl"],
			"CO2 fire extinguishing": ["Tyco Fire & Integrated Soltutions"],
			"Pipe/cable penetrations": ["Roxtec"],
			"Air vents": ["John Gjerde"],
			"Lice treatment facility": ["Flatsetsund Engineering"],
			Filtration: ["HDU 27/108, PTU1 27/108", "Øwre Johnsen"],
		},
	},
	"Ronja Silver": {
		"Vessel built": "2023",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "92.50 m",
		"Length b.p.": null,
		"Breadth mld": "20.00 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "14",
		"Service speed": "11 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["2xC25:33 L9A", "Bergen Engines"],
			"Propulsion system": ["Promas", "Konsgberg Maritime"],
			"Propulsion motor": ["Marelli B5J", "Kongsberg Maritime"],
			Gear: ["RG-0650GDC", "Kongsberg Maritime"],
			"Steering gear": ["SR 662 FCP", "Kongsberg Maritime"],
			Thrusters: ["2xTT 1650 DPN FP", "Kongsberg Maritime"],
			"Shore/Emergency generator": ["Scania DI139 1M", "Nogva Motorfabrikk"],
			"Rack coolers": ["Hydroniq"],
			"Deck cranes": ["4 stk.", "Storm Cranes"],
			Winches: ["Adria Winch"],
			Walkway: ["Gurskøy"],
			"Free-fall lifeboat": ["Viking Norsafe Life-Saving Equipment"],
			"MOB boat": ["Mare Safety"],
			"HVAC system": ["Aeron"],
			"Toilet system": ["Jets Vacuum"],
			"Galley equipment": ["Mare Safety"],
			Furniture: ["ShipNor"],
			"RSW system": ["PTG Frionordica"],
			"Fish handling system": ["MMC First Process"],
			"IAS/PM": ["K-Chief", "Kongsberg Maritime"],
			"Paint systems": ["Carboline"],
			"Electrical installations": ["Hareid Group"],
			"Fire fighting system": ["John. Con. Nor. avd. Tyco Mar."],
			Actuators: ["Eltorque"],
			"Hull yard": ["Hat-San"],
			"Classification society": ["DNV"],
			"Helm seats": ["NorSap"],
			"Pipe/cable penetrations": ["Roxtec"],
			Typhon: ["R. Stahl Tranberg"],
			"Fire detection": ["John. Con. Nor. avd. Tyco Mar."],
			"Pipe system": ["Pipe Systems Engineering", "Tomrefjord Rør og Montering"],
			"Safety equipment": ["Viking Norsafe Life-Saving Equipment"],
		},
	},
	"Ronja Skilsøy": {
		"Vessel built": "2020",
		"Vessel design": ["Salt Ship Design"],
		"Class definition": null,
		"Length o.a.": "84.40 m",
		"Length b.p.": null,
		"Breadth mld": "16 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			Motor: ["3x Yanmar 1370 kW"],
			Thrusters: ["Schottel"],
			Generator: ["Scania 220 kW"],
			"Navigation & Communication": ["Ozsay Deniz Elektonigi "],
			"Firefighting equipment": ["Autronica"],
			"Life boats": ["RFD/Survitec"],
			"Wheelhouse chairs": ["Aludesign"],
			Archors: ["Yapas"],
		},
	},
	"Ronja Star": {
		"Vessel built": "2022",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "87.10 m",
		"Length b.p.": null,
		"Breadth mld": "18.00 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "12 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["3xPon Cat 3512C", "Pon Power"],
			"Propulsion engines": ["2x1499 kW", "Kongsberg Maritime"],
			Gear: ["650GHC-V-SC500", "Kongsberg Maritime"],
			"Steering gear": ["SR662 FCP", "Kongsberg Maritime"],
			Thrusters: ["2xTT1650FP", "Kongsberg Maritime"],
			"Shore/Emergency generator": ["Scania DI1375M", "Nogva Motorfabrikk"],
			"Rack coolers": ["Hydroniq"],
			"Deck cranes": ["4 stk.", "Storm Cranes"],
			Winches: ["Kongsberg Maritime"],
			"Fish handling system": ["MMC First Process"],
			Walkway: ["Gurskøy"],
			"MOB boat": ["Mare Safety"],
			"IAS-/PMS-system": ["Kongsberg Maritime"],
			"Electrical installations": ["HG Teknikk"],
			"Navigation/Communication systems": ["Furuno", "HG Teknikk"],
			"HVAC system": ["AF Gruppen"],
			"Toilet system": ["Jets Vacuum"],
			"RSW system": ["PTG Frionordica"],
			"Galley equipment": ["Mare Safety"],
			"Pipe/cable penetrations": ["Roxtec"],
			"Fire detection/Sprinkler extinguishing system": ["Tyco"],
			"Exterior/Interior paint": ["Carboline"],
			"Classification society": ["DNV"],
			Design: ["Kongsberg Maritime"],
			Actuators: ["Eltorque"],
			Furnishing: ["ShipNor"],
			Typhon: ["R. Stahl Tranberg"],
			"Pipe installations": ["Pipe Systems Engineering"],
		},
	},
	"Ronja Storm": {
		"Vessel built": "2019",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "116.00 m",
		"Length b.p.": null,
		"Breadth mld": "3.00 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": null,
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Fuel oil": ["410 m³"],
			"Fresh water": ["4733 m³"],
			"Grey water": ["12.7 m³"],
			"Generator set": ["Caterpillar", "Pon Power"],
			"Main engines": ["4xCaterpillar 3516C", "Pon Power"],
			Generators: ["4xNegr 500 MC4", "NES"],
			"Emergency generator": ["Caterpillar 7.1", "Pon Power"],
			"Propulsion system/Thrusters": ["Kongsberg Maritime"],
			"FO pumps": ["Allweiler"],
			"FO separators": ["Øwre-Johnsen"],
			Coolers: ["Sperre"],
			Cranes: ["Triplex MacGregor"],
			"Lifeboats Cranes/Winches": ["Palfinger Marine"],
			"Fish handling system": ["MMC First Process"],
			"MOB boat/cranes": ["Maritime Partner"],
			Lifeboats: ["Palfinger Ned-Deck"],
			"Rescue equipment": ["Viking Norsafe Life-Saving Equipment"],
			"Navigation lights": ["R. Stahl Tranberg"],
			"HP washers": ["HL Skjong"],
			"Anchor equipment": ["4050 kg", "Fossen Trading"],
			"Furnishing/Galley equipment": ["Beha Hedo Ind.", "Maritime Montering"],
			"Ventilation system": ["Aeron"],
			"Exterior doors": ["Libra Plast"],
			"Interior doors": ["IMS"],
			Windows: ["Bohamet"],
			"Windshield wipers": ["Servi"],
			Septikpumper: ["Ahlsell"],
			"Fire alarm": ["Autronica"],
			"Navigation/Communication systems": ["Furuno Norge", "Norwegian Control Systems"],
			"Internal communication": ["Jotron"],
			"IAS/EMS/Transformers": ["Norwegian Electric Systems"],
			"Fire equipment": ["Survitec"],
			Paint: ["Carboline/Multi Marine"],
			"ICCP/ICAF": ["MPE Cathodic"],
			"Fire detection/water mist extinguishing system": ["Tyco Fire & Integrated Sys."],
			"Pipe system installation": ["Fjordpipe"],
			"Pipe/cable penetrations": ["Roxtec"],
			Pumps: ["Allweiler"],
		},
	},
	"Ronja Supporter": {
		"Vessel built": "2016",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "69.86 m",
		"Length b.p.": "66.98 m",
		"Breadth mld": "12.00 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": "12.6 knots",
		Charterer: "Scottish Seafarms",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Wärtsila Finland Oy"],
			"Auxiliary engines": ["Pon Power"],
			"Emergency/harbor generator": ["Nogva Motorfabrikk"],
			"Gear/propulsion system/maneuvering": ["Scana Volda"],
			"Side thrusters": ["Brunvoll"],
			"Steering gear": ["Rolls-Royce Marine"],
			Pumps: ["PG Flow Solutions"],
			"Deck cranes": ["Bergen Hydraulic"],
			"Anchor winch": ["Rapp Hydema"],
			"Vacuum pump system": ["Havyard MMC"],
			"Fish counters": ["AquaScan"],
			"Ozone system": ["Redox"],
			"UV system/louse filter": ["Sterner"],
			"MOB boat/cranes": ["Mare Safety"],
			"Anchor equipment": ["Fossen Shipping"],
			"LED floodlights": ["Luminell"],
			"Smolt counters": ["Vaki"],
			Interior: ["R&M Ship Interior"],
			"Helm seats": ["Alu Design"],
			"Ventilation system": ["Wangsmo"],
			"Interior doors": ["Baggerød"],
			"Exterior doors": ["Libra Plast"],
			Window: ["Bohamet Spolka Akcyjna"],
			"Provisions cooling system": ["Trondheim Kulde"],
			"Cable/pipe penetrations": ["Roxtec"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["Furuno Norge", "O. Øverland"],
			"Fire/Rescue equipment": ["Erling Haug"],
			Paint: ["International/Westing"],
			"Valve/pipe equipment": ["Robinet", "Brødrene Dahl"],
			"CO2 fire extinguishing": ["Wilhelmsen Technical Solutions"],
			"Windscreen wipers": ["Decca Straight Line", "Decca"],
			"Oil filters": ["Øwre-Johnsen"],
		},
	},
	"Ronja Vest": {
		"Vessel built": "2021",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "87.10 m",
		"Length b.p.": "84.80",
		"Breadth mld": "18.00 m",
		Bext: null,
		Depth: "8.00 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": "7.30 m",
		Accommodation: "12",
		"Service speed": "12 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Biomass/FW-buffer": ["510.50 m³"],
			"Fuel oil": ["276.90 m³"],
			"Fresh water": ["37.50 m³"],
			"Technical fresh water": ["274.50 m³"],
			"Ballast water": ["1,064.30 m³"],
			Urea: ["47.00 m³"],
			"Grey water": ["17.50 m³"],
			"Bilge/sludge": ["28.50 m³"],
			"Main engines": ["3x Caterpillar á 1550 ekW", "Pon Power"],
			Gear: ["Kongsberg Maritime"],
			"Propulsion system": ["2x1499 kW", "Kongsberg Maritime"],
			"Tunnel thrusters": ["TT1650FP, 630 kW", "Kongsberg Maritime"],
			"Emergency generator": ["Scania DI 13 75 M", "Nogva Motorfabrikk"],
		},
	},
	"Ronja Vita": {
		"Vessel built": "2024",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "76.96 m",
		"Length b.p.": null,
		"Breadth mld": "17.80 m",
		Bext: null,
		Depth: null,
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "12",
		"Service speed": "13 knots",
		Charterer: "--",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Yanmar 6EY26W", "Maritim Motor"],
			Gear: ["Brunvoll Volda"],
			"Propulsion system": ["Brunvoll Volda"],
			"Auxiliary engines": ["2xCAT 3512 C", "Pon Power"],
			"Emergency generator": ["Scania DI 13 75 M", "Nogva Motorfabrikk"],
			"Side thrusters": ["Brunvoll"],
			Pumps: ["PG Flow Solutions", "Allweiler"],
			"Steering gear": ["Kongsberg Maritime"],
			"Valves/Pipes equipment": ["Robinet", "Brødrene Dahl"],
			Dieselseparator: ["Øwre-Johnsen"],
			"Fire fighting engine room": ["Johnson Controls Norway"],
			"MOB boat": ["Mare Safety"],
			"MOB boat cranes": ["Storm Cranes"],
			"Anchor winch": ["Scan"],
			"Anchor equipment": ["Fossen Shipping"],
			"Deck cranes": ["4 stk.", "Storm Cranes"],
			"Loading system": ["MMC First Process"],
			"Unloading system": ["MMC First Process"],
			"Sorting counter": ["MMC First Process"],
			"Fish counters": ["AquaScan", "MSD Animal Health Norway"],
			"Ozone system": ["Sterner"],
			"Oxygen system": ["Sterner"],
			"RSW system": ["PTG Frionordica"],
			"Lice filter": ["MossHydro"],
			Furnishing: ["R&M Ship Interior"],
			Furniture: ["Shipnor"],
			"Ventilation system": ["Copra Drift"],
			"Provision fridge system": ["Multi Kulde Vest"],
			"Interior doors": ["Baggerød", "R&M Ship Interior"],
			"Toilet facilities": ["Jets"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["O. Øverland"],
			"Fire equipment": ["Certex Norge"],
			"Rescue equipment": ["Certex Norge"],
			"Exterior doors": ["Libra-Plast"],
			Windows: ["Karaca Gemi"],
			Paint: ["Carboline Norge"],
			Actuators: ["Eltorque"],
			"Windshield wipers": ["Exalto Decca Wiper"],
			"Pipe/cable penetrations": ["Roxtec"],
			"Navigation lights": ["Tranberg"],
			Design: ["AAS 3002 ST", "Aas Mek Verksted"],
		},
	},
	Ronjafisk: {
		"Vessel built": "2019",
		"Vessel design": null,
		"Class definition": null,
		"Length o.a.": "69.96 m",
		"Length b.p.": null,
		"Breadth mld": "17.80 m",
		Bext: null,
		Depth: "5.90 m",
		"Design draft": null,
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: null,
		"Service speed": "13 kn",
		Charterer: "Bakkafrost",
		CapacityName: "Cargo hold",
		CapacityUnit: "m³",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Main engines": ["Yanmar 6EY26W, 1900 kW", "Maritim Motor"],
			Gear: ["Brunvoll Volda"],
			"Propulsion system": ["Brunvoll Volda"],
			"Auxiliary engines": ["Cat", "Pon Power"],
			Thrusters: ["Brunvoll"],
			"Steering gear": ["Kongsberg Maritime"],
			"Filtration lub oil/fuel": ["Øwre-Johnsen"],
			"Deck cranes": ["Bergen Hydraulic"],
			"Anchor winch": ["Adria Winch"],
			"Loading/Unloading system": ["MMC First Process"],
			"Fish counters": ["AquaScan", "Vaki"],
			"Smolt counter": ["Vaki"],
			Sorteringsteller: ["MMC First Process"],
			"Ozone system": ["Sterner"],
			"RSW system": ["PTG Frionordica"],
			"UV-system/Lice filter": ["Sterner"],
			"Anchor equipment": ["Fossen Shipping"],
			"MOB boat/cranes": ["Maritime Partner"],
			Lights: ["Luminell"],
			Typhon: ["R. Stahl Tranberg"],
			"Navigation lights/search lights": ["Glamox"],
			Furnishing: ["R&M Ship Interior", "Shipnor"],
			"Ventilation system": ["Wangsmo"],
			"Provision fridge system": ["Trondheim Kulde"],
			"Exterior doors": ["Libra-Plast"],
			"Interior doors": ["Baggerød", "R&M Ship Interior"],
			"Interior lights": ["Glamox"],
			Windows: ["Bohamet"],
			"Toilet facilities": ["Jets"],
			"Electrical installations": ["Vik Elektro"],
			Electronics: ["HG Marine Electronics"],
			Pumps: ["PG Flow Solutions", "Allweiler"],
			"Fire/Rescue equipment": ["Certex Norge"],
			Paint: ["Multi Marine", "Carboline"],
			"Valves/Pipes equipment": ["Robinet"],
			"Valve equipment": ["Brødrene Dahl"],
			Financing: ["Nordea"],
			"Fire fighting system": ["Tyco Fire & Integrated Solutions"],
		},
	},
	// VARD
	"REV Ocean": {
		"Vessel built": "2025",
		"Vessel design": null,
		"Class definition": [
			"✠ 1A Passenger ship BIS Battery(Power) BWM(T) Clean(Design, Tier III) E0 HELDK(S, H, F) Ice(1C) NAUT(OC) Recyclable Silent(R) TMON(oil lubricated)",
		],
		"Length o.a.": "194.9 m",
		"Length b.p.": "162.6 m",
		"Breadth mld": "22 m",
		Bext: "26 m",
		Depth: "7.25 m",
		"Design draft": "5.65 m",
		"Summer draft": null,
		"Scantling draft": null,
		Accommodation: "90",
		"Service speed": "11 knots",
		Charterer: "--",
		CapacityName: "Gross tonnage",
		CapacityUnit: "",
		filterGroup: null,
		isUnderConfiguration: false,
		additionalProps: {
			"Ice class": ["Polar Class 6"],
			"Installed power": ["4 × Wärtsilä 8L26 (4 × 2.7 MW)"],
			"Maximum speed": ["17 knots"],
			Range: ["21,120 nmi"],
			"Boats & landing craft carried": ["2 trawlers, 1 submersible"],
			Crew: ["30"],
			"Aviation facilities": ["2 helipads", "ACH145 Airbus Corporate helicopter"],
		},
	},
}
